// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes LandingPageV4_spin__hGHqY {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Main page wrapper */
.LandingPageV4_pageWrapper__nkocj {
  background: #f8f9ff;
  min-height: 100vh;
  font-family: 'Manrope', 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Hero + TrustBar: fill first viewport below header so stats row stays visible */
.LandingPageV4_heroViewport__rSy59 {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 72px);
  min-height: calc(100dvh - 72px);
}

.LandingPageV4_heroViewport__rSy59 .LandingPageV4_trustBar__oHfgX {
  flex-shrink: 0;
}

.LandingPageV4_innerWrapper__jP322 {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
}

/* ===== Header ===== */
.LandingPageV4_header__7wrpI {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid rgba(130, 166, 207, 0.22);
  background:
    radial-gradient(circle at 82% -80%, rgba(10, 100, 249, 0.32), transparent 34%),
    linear-gradient(118deg, #071c38 0%, #091e3a 54%, #0c315c 100%);
  box-shadow: 0 8px 24px rgba(4, 20, 42, 0.18);
}

.LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
  width: 100%;
  max-width: 1600px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.LandingPageV4_logo__OsjVE {
  width: 148px;
  max-width: 100%;
  height: auto;
  cursor: pointer;
  filter: brightness(0) invert(1);
}

.LandingPageV4_logoButton__qGn\\+B {
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  display: inline-grid;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0);
  cursor: pointer;
  transition:
    border-color 160ms ease,
    background 160ms ease;
}

.LandingPageV4_logoButton__qGn\\+B:hover {
  border-color: rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.07);
}

.LandingPageV4_headerButtons__d7rrc {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
}

.LandingPageV4_signInBtn__IPzgy {
  min-height: 44px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 750;
  color: #f7faff;
  background: rgba(255, 255, 255, 0.065);
  border: 1px solid rgba(151, 183, 221, 0.28);
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    transform 160ms ease;
}

.LandingPageV4_signInBtn__IPzgy:hover {
  color: #ffffff;
  border-color: rgba(117, 173, 255, 0.68);
  background: rgba(10, 100, 249, 0.18);
  transform: translateY(-1px);
}

.LandingPageV4_signUpBtn__VZWBW {
  min-height: 44px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 800;
  color: white;
  background: linear-gradient(145deg, #1a78ff, #0755d8);
  border: 1px solid rgba(126, 181, 255, 0.38);
  border-radius: 12px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(0, 76, 190, 0.32);
  transition:
    background 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;
}

.LandingPageV4_signUpBtn__VZWBW:hover {
  background: linear-gradient(145deg, #2b84ff, #0960ef);
  box-shadow: 0 10px 24px rgba(0, 88, 218, 0.42);
  transform: translateY(-1px);
}

/* Profile menu styles */
.LandingPageV4_profileMenuWrapper__nTh4O {
  position: relative;
}

.LandingPageV4_profileBtn__w0iq8 {
  height: 44px;
  width: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.09);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(151, 183, 221, 0.28);
  cursor: pointer;
  transition:
    border-color 160ms ease,
    background 160ms ease;
}

.LandingPageV4_profileBtn__w0iq8:hover {
  border-color: rgba(117, 173, 255, 0.68);
  background: rgba(10, 100, 249, 0.2);
}

.LandingPageV4_iconSm__h-3YS {
  width: 20px;
  height: 20px;
}

.LandingPageV4_profileMenu__\\+Xzo\\+ {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 12px;
  width: 288px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  z-index: 50;
  overflow: hidden;
}

.LandingPageV4_profileHeader__weHYT {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
}

.LandingPageV4_profileName__cem-L {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.LandingPageV4_profileEmail__MFvBI {
  font-size: 14px;
  color: #6b7280;
  word-break: break-all;
  margin: 2px 0 0 0;
}

.LandingPageV4_menuList__34mGD {
  list-style: none;
  padding: 4px 0;
  margin: 0;
}

.LandingPageV4_menuItemBtn__7jVDt {
  width: 100%;
  min-height: 44px;
  padding: 10px 16px;
  text-align: left;
  color: #1f2937;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.LandingPageV4_menuItemBtn__7jVDt:hover {
  background: #f9fafb;
}

.LandingPageV4_menuDivider__qbWQA {
  border-top: 1px solid #f3f4f6;
}

.LandingPageV4_logoutBtn__HHe98 {
  width: 100%;
  min-height: 44px;
  padding: 12px 16px;
  text-align: left;
  color: #111827;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.LandingPageV4_logoutBtn__HHe98:hover {
  background: #f9fafb;
}

/* ===== Trust Signals / Stats Bar ===== */
.LandingPageV4_trustBar__oHfgX {
  position: relative;
  z-index: 10;
  margin-top: -56px;
  padding: 0 32px;
  margin-bottom: 16px;
}

.LandingPageV4_trustBarCard__C43QQ {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 82, 255, 0.06);
  padding: 32px 40px;
  max-width: 1280px;
  margin: 0 auto;
}

.LandingPageV4_trustBarGrid__S56x- {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.LandingPageV4_trustItem__NkSuB {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 16px;
  border-right: 1px solid #e2e8f0;
}

.LandingPageV4_trustItem__NkSuB:last-child {
  border-right: none;
}

.LandingPageV4_trustIcon__-ANnJ {
  width: 48px;
  height: 48px;
  background: #eff6ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0052ff;
  flex-shrink: 0;
}

.LandingPageV4_trustTextWrap__r6u5W {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.LandingPageV4_trustText__jxtdf {
  font-size: 24px;
  font-weight: 900;
  color: #0b1c30;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.LandingPageV4_trustSubtext__TKs1m {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* ===== Category Strip ===== */
.LandingPageV4_categoryStrip__Ud\\+Yg {
  padding: 64px 0;
  background: #f8f9ff;
}

.LandingPageV4_categoryHeader__bAQgF {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 32px;
  gap: 24px;
}

.LandingPageV4_categoryHeaderText__K554- {
  flex: 1 1;
}

.LandingPageV4_categoryTitle__BXOKV {
  font-size: 30px;
  font-weight: 800;
  color: #0b1c30;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
}

.LandingPageV4_categoryDescription__Dd9uU {
  font-size: 16px;
  color: #64748b;
  max-width: 480px;
  line-height: 1.5;
}

.LandingPageV4_categoryNavButtons__fT4BV {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.LandingPageV4_categoryArrow__8sgtP {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: transparent;
  border: 1.5px solid rgba(195, 197, 217, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #434656;
  flex-shrink: 0;
  transition: all 0.2s;
}

.LandingPageV4_categoryArrow__8sgtP:hover:not(:disabled) {
  background: white;
  border-color: #0052ff;
  color: #0052ff;
}

.LandingPageV4_categoryArrowDisabled__ukwDy {
  opacity: 0.3;
  cursor: default;
}

.LandingPageV4_categoryScrollWrapper__O5aqT {
  position: relative;
  min-width: 0;
  overflow: hidden;
}

.LandingPageV4_categoryFadeLeft__x63YP,
.LandingPageV4_categoryFadeRight__XERjO {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 60px;
  z-index: 2;
  pointer-events: none;
}

.LandingPageV4_categoryFadeLeft__x63YP {
  left: 0;
  background: linear-gradient(to right, #f8f9ff, transparent);
}

.LandingPageV4_categoryFadeRight__XERjO {
  right: 0;
  background: linear-gradient(to left, #f8f9ff, transparent);
}

.LandingPageV4_categoryPills__kiyYa {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  gap: 16px;
  overflow-x: auto;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: 8px 4px;
  scroll-snap-type: x mandatory;
}

.LandingPageV4_categoryPills__kiyYa::-webkit-scrollbar {
  display: none;
}

.LandingPageV4_categoryPill__bHh52 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px;
  background: white;
  border: none;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 700;
  color: #0b1c30;
  cursor: pointer;
  flex-shrink: 0;
  width: 160px;
  min-height: 140px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.25s;
  scroll-snap-align: start;
  text-align: center;
  font-family: inherit;
  appearance: none;
}

.LandingPageV4_categoryPill__bHh52:disabled {
  cursor: wait;
}

.LandingPageV4_categoryIconContainer__GB8mM {
  width: 80px;
  height: 80px;
  background: #e5eeff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  color: #0b1c30;
  font-size: 36px;
}

.LandingPageV4_categoryPill__bHh52:hover {
  box-shadow: 0 8px 24px rgba(0, 82, 255, 0.1);
}

.LandingPageV4_categoryPill__bHh52:hover .LandingPageV4_categoryIconContainer__GB8mM {
  background: #0052ff;
  color: white;
}

/* ===== Content Sections (kept for backward compat) ===== */
.LandingPageV4_contentSection__moDt4 {
  background: white;
  padding: 80px 0;
  display: flex;
  align-items: center;
  gap: 64px;
}

.LandingPageV4_contentSectionReverse__pZZif {
  flex-direction: row-reverse;
  background: #f9fafb;
}

.LandingPageV4_contentText__QVf6o {
  flex: 1 1;
}

.LandingPageV4_contentTitle__u\\+nLX {
  font-size: 36px;
  font-weight: 700;
  color: #0b1c30;
  margin-bottom: 20px;
  line-height: 1.15;
}

.LandingPageV4_contentDescription__fXIzg {
  font-size: 18px;
  color: #475569;
  line-height: 1.65;
  margin-bottom: 28px;
}

.LandingPageV4_contentImage__LO-Oi {
  flex: 1 1;
  border-radius: 16px;
  overflow: hidden;
}

.LandingPageV4_ctaBtn__MWGPU {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  margin-top: 4px;
  background: transparent;
  color: #0052ff;
  border: 1.5px solid #0052ff;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition:
    background 0.2s,
    color 0.2s;
}

.LandingPageV4_ctaBtn__MWGPU:hover {
  background: #0052ff;
  color: white;
}

/* ===== Order Options / Services ===== */
.LandingPageV4_orderOptions__onirQ {
  background: #eff4ff;
  padding: 80px 0;
}

.LandingPageV4_orderOptionsHeader__eEHlu {
  text-align: center;
  margin-bottom: 48px;
}

.LandingPageV4_sectionTitle__q9iWx {
  font-size: 36px;
  font-weight: 700;
  color: #0b1c30;
  margin-bottom: 12px;
}

.LandingPageV4_sectionSubtitle__tWkjP {
  font-size: 18px;
  color: #475569;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.55;
}

.LandingPageV4_orderOptionsGrid__gtton {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.LandingPageV4_orderCard__cl6WT {
  position: relative;
  height: 550px;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  box-shadow: 0 16px 48px rgba(0, 82, 255, 0.08);
}

.LandingPageV4_orderCard__cl6WT:hover .LandingPageV4_orderCardImageFull__dETSC {
  transform: scale(1.05);
}

.LandingPageV4_orderCardImageFull__dETSC {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 1000ms ease;
}

.LandingPageV4_orderCardOverlay__Lc2fS {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.85),
    rgba(0, 0, 0, 0.35) 50%,
    transparent
  );
  z-index: 1;
}

.LandingPageV4_orderCardContentOverlay__sJmUk {
  position: relative;
  z-index: 2;
  padding: 48px;
  width: 100%;
}

.LandingPageV4_orderCardBadge__ONFKd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0052ff;
  color: white;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 16px;
  box-shadow: 0 4px 16px rgba(0, 82, 255, 0.4);
}

.LandingPageV4_orderCardTitle__9Wrq3 {
  font-size: 36px;
  font-weight: 800;
  color: white;
  letter-spacing: -0.03em;
  margin-bottom: 12px;
}

.LandingPageV4_orderCardText__3Kb9a {
  font-size: 18px;
  color: #e2e8f0;
  margin-bottom: 0;
  /* padding so gap to CTA doesn’t collapse with button margins */
  padding-bottom: 24px;
  line-height: 1.6;
  max-width: 400px;
}

.LandingPageV4_orderCardBtnPrimary__W22cs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: white;
  color: #0b1c30;
  border: none;
  border-radius: 12px;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Manrope', sans-serif;
  cursor: pointer;
  transition: background 0.2s;
}

.LandingPageV4_orderCardBtnPrimary__W22cs:hover {
  background: #f1f5f9;
}

.LandingPageV4_orderCardBtnOutline__HB1Yo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: white;
  color: #0b1c30;
  border: none;
  border-radius: 12px;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Manrope', sans-serif;
  cursor: pointer;
  transition: background 0.2s;
}

.LandingPageV4_orderCardBtnOutline__HB1Yo:hover {
  background: #f1f5f9;
}

/* ===== Partner Section ===== */
.LandingPageV4_partnerSection__dGi7F {
  padding: 80px 0;
  background: #f8f9ff;
}

.LandingPageV4_partnerCard__arAP1 {
  background: #003ec7;
  border-radius: 32px;
  padding: 80px;
  display: flex;
  align-items: center;
  gap: 64px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 62, 199, 0.2);
}

.LandingPageV4_partnerCardContent__PJG6c {
  position: relative;
  z-index: 1;
  flex: 1 1;
}

.LandingPageV4_partnerTitle__lXaxl {
  font-size: clamp(32px, 4vw, 56px);
  font-weight: 900;
  color: white;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-bottom: 24px;
}

.LandingPageV4_partnerDescription__TKVul {
  font-size: 18px;
  color: rgba(191, 219, 254, 0.9);
  line-height: 1.65;
  margin-bottom: 0;
  padding-bottom: 24px;
  max-width: 480px;
}

.LandingPageV4_partnerGlassBtn__n1\\+62 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: white;
  border-radius: 12px;
  padding: 18px 32px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  text-decoration: none;
}

.LandingPageV4_partnerGlassBtn__n1\\+62:hover {
  background: rgba(255, 255, 255, 0.2);
}

.LandingPageV4_phoneMockup__8Le8n {
  width: 310px;
  height: 630px;
  background: #020617;
  border-radius: 48px;
  overflow: hidden;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 0 4px #0f172a,
    0 20px 50px -10px rgba(0, 0, 0, 0.5);
  transform: rotate(3deg);
}

.LandingPageV4_phoneScreen__n7Wai {
  width: 100%;
  height: 100%;
  background: #020617;
  border-radius: 40px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.3);
}

.LandingPageV4_phoneScreenContent__pGBSB {
  position: absolute;
  inset: 0;
  padding: 24px;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Merchant Dashboard Header */
.LandingPageV4_phoneMerchantHeader__t\\+PPi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.LandingPageV4_phoneMerchantLabel__TDwG2 {
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 2px;
}

.LandingPageV4_phoneMerchantTitle__ecGIQ {
  font-size: 18px;
  font-weight: 800;
  color: white;
}

.LandingPageV4_phoneMerchantAvatar__rCZwn {
  width: 40px;
  height: 40px;
  background: rgba(0, 82, 255, 0.2);
  border-radius: 50%;
  border: 1px solid rgba(0, 82, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Metric Card */
.LandingPageV4_phoneMetricCard__\\+vngV {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.LandingPageV4_phoneMetricHeader__Ayh\\+- {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.LandingPageV4_phoneMetricLabel__bkJnc {
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.LandingPageV4_phoneMetricBadge__mc1g2 {
  font-size: 10px;
  font-weight: 700;
  color: #4ade80;
  background: rgba(74, 222, 128, 0.1);
  padding: 2px 8px;
  border-radius: 999px;
}

.LandingPageV4_phoneMetricValue__pI-tx {
  font-size: 24px;
  font-weight: 900;
  color: white;
}

/* Sales Growth Chart Card */
.LandingPageV4_phoneChartCard__Ygasa {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.LandingPageV4_phoneChartHeader__E8nzc {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
}

.LandingPageV4_phoneChartValue__c76YJ {
  font-size: 20px;
  font-weight: 900;
  color: white;
  margin-top: 2px;
}

.LandingPageV4_phoneChartMiniBar__\\+yEir {
  display: flex;
  gap: 3px;
  height: 32px;
  align-items: flex-end;
}

.LandingPageV4_phoneMiniBar1__4XfRW {
  width: 3px;
  background: rgba(0, 82, 255, 0.2);
  border-radius: 999px;
}

.LandingPageV4_phoneMiniBar2__G2Qdp {
  width: 3px;
  background: rgba(0, 82, 255, 0.4);
  border-radius: 999px;
}

.LandingPageV4_phoneMiniBar3__o68Z1 {
  width: 3px;
  background: #0052ff;
  border-radius: 999px;
}

.LandingPageV4_phoneLineChart__rA0LR {
  height: 80px;
  width: 100%;
}

/* Order Volume Bar Chart */
.LandingPageV4_phoneBarChartCard__ebe5c {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.LandingPageV4_phoneBarChartBars__F0ByG {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 96px;
  gap: 6px;
  padding: 0 4px;
  margin-top: 12px;
}

.LandingPageV4_phoneBar__C-u3T {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px 2px 0 0;
}

.LandingPageV4_phoneBarActive__dwqtq {
  background: #0052ff;
}

.LandingPageV4_phoneNotch__73TVK {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 12px;
}

.LandingPageV4_phoneNotchLine__gGipL {
  width: 80px;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 999px;
}

/* ===== Newsletter Section ===== */
.LandingPageV4_newsletter__DV3bX {
  --newsletter-column-width: 480px;
  padding: 42px 0 38px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-top: 1px solid #e1e9f3;
  border-bottom: 1px solid #d9e5f2;
  text-align: center;
}

.LandingPageV4_newsletterTitle__OMI9U {
  font-size: clamp(28px, 2.5vw, 34px);
  font-weight: 900;
  color: #0b1c30;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
  line-height: 1.15;
}

.LandingPageV4_newsletterSubtitle__-kL1i {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 18px;
  max-width: var(--newsletter-column-width);
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.LandingPageV4_newsletterSignup__Mv7Mn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
}

.LandingPageV4_newsletterFormWrapper__DXthJ {
  max-width: var(--newsletter-column-width);
  width: 100%;
  margin: 0 auto;
}

.LandingPageV4_newsletterForm__SlMqm {
  display: flex;
  gap: 12px;
}

.LandingPageV4_newsletterInput__FNmSs {
  flex: 1 1;
  min-width: 0;
  min-height: 52px;
  background: #f8f9ff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
  padding: 16px 20px;
  color: #0b1c30 !important;
  font-size: 16px;
  font-family: 'Manrope', sans-serif;
  outline: none;
  transition: border-color 0.2s;
  pointer-events: auto !important;
  user-select: text !important;
  -webkit-user-select: text !important;
}

.LandingPageV4_newsletterInput__FNmSs:focus {
  border-color: #0052ff !important;
}

.LandingPageV4_newsletterBtn__kYFon {
  min-height: 52px;
  background: linear-gradient(135deg, #003ec7 0%, #0052ff 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 28px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Manrope', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 82, 255, 0.15);
}

.LandingPageV4_newsletterBtn__kYFon:hover {
  box-shadow: 0 8px 24px rgba(0, 82, 255, 0.3);
}

.LandingPageV4_newsletterBtn__kYFon:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.LandingPageV4_newsletterTerms__wLreU {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 12px;
  margin-bottom: 0;
  line-height: 1.45;
}

@media (min-width: 1025px) {
  .LandingPageV4_newsletterTerms__wLreU {
    white-space: nowrap;
    width: max-content;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}

.LandingPageV4_termsRow__jOtzU {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  font-size: 15px;
  color: #9ca3af;
  cursor: pointer;
}

.LandingPageV4_hiddenCheckbox__sn7M9 {
  display: none;
}

.LandingPageV4_customCheckbox__vs\\+4n {
  width: 18px;
  height: 18px;
  border: 1px solid #4b5563;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.LandingPageV4_checkIcon__gjn4F {
  color: #0052ff;
  font-size: 12px;
}

.LandingPageV4_termsLabel__CKxhZ {
  font-size: 16px;
  color: #9ca3af;
  line-height: 1.4;
}

.LandingPageV4_termsLabel__CKxhZ a {
  color: #60a5fa;
  text-decoration: none;
}

.LandingPageV4_termsLabel__CKxhZ a:hover {
  text-decoration: underline;
}

/* ===== Footer ===== */
.LandingPageV4_footer__\\+l-US {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background:
    radial-gradient(circle at 84% -28%, rgba(10, 100, 249, 0.3), transparent 38%),
    linear-gradient(135deg, #07192f 0%, #091e3a 52%, #0c294c 100%);
  color: #ffffff;
  padding: 30px 0 0;
  border-top: 1px solid #173a63;
}

.LandingPageV4_footer__\\+l-US::before {
  position: absolute;
  z-index: -1;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 76%);
  content: '';
  pointer-events: none;
}

.LandingPageV4_footerNewsletter__H373\\+ {
  display: none;
}

.LandingPageV4_footerContent__93wnF {
  padding: 0;
}

.LandingPageV4_footerGrid__QMMCm {
  display: grid;
  grid-template-columns: minmax(220px, 1.65fr) repeat(3, minmax(112px, 0.75fr)) minmax(210px, 1.25fr);
  gap: clamp(20px, 2.8vw, 42px);
  margin-bottom: 20px;
  align-items: start;
}

.LandingPageV4_footerHelpText__GsrfR {
  font-size: 13px;
  color: #a9bad0;
  line-height: 1.5;
  margin: 0 0 8px;
}

.LandingPageV4_footerContactLink__is6TE {
  display: inline-flex !important;
  min-height: 40px;
  align-items: center;
  gap: 8px;
}

.LandingPageV4_footerContactLink__is6TE .LandingPageV4_material-symbols-outlined__Ug37d {
  color: #75adff;
}

.LandingPageV4_footerBrand__ol-2d {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.LandingPageV4_footerBrand__ol-2d > a {
  width: fit-content;
  min-height: 44px;
  display: inline-grid;
  place-items: center;
  border-radius: 12px;
}

.LandingPageV4_footerBrandDescription__kq\\+iG {
  font-size: 14px;
  color: #a9bad0;
  line-height: 1.5;
  max-width: 280px;
  margin: 0;
}

.LandingPageV4_footerColumn__cTUqZ h4 {
  font-size: 11px;
  font-weight: 800;
  margin: 0 0 8px;
  color: #75adff;
  text-transform: uppercase;
  letter-spacing: 0.13em;
  line-height: 16px;
}

.LandingPageV4_footerColumn__cTUqZ ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.LandingPageV4_footerColumn__cTUqZ li {
  margin: 0;
}

.LandingPageV4_footerColumn__cTUqZ a {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  color: #bdcce0;
  text-decoration: none;
  font-size: 13px;
  font-weight: 650;
  line-height: 18px;
  transition: color 160ms ease;
}

.LandingPageV4_footerColumn__cTUqZ a:hover {
  color: #ffffff;
}

.LandingPageV4_footerLegalLink__w0dWo {
  text-decoration: underline !important;
  text-decoration-color: rgba(117, 173, 255, 0.45) !important;
  text-underline-offset: 4px;
}

.LandingPageV4_footerBottom__L6WSo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  padding: 10px 0;
  border-top: 1px solid rgba(130, 166, 207, 0.22);
}

.LandingPageV4_footerLogo__t27DJ {
  width: 132px;
  max-width: 100%;
  height: auto;
  display: block;
  filter: brightness(0) invert(1);
}

.LandingPageV4_footerSocial__OIJVr {
  display: flex;
  gap: 12px;
}

.LandingPageV4_footerSocial__OIJVr a {
  color: #dce9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(130, 166, 207, 0.28);
  background: rgba(255, 255, 255, 0.065);
  transition: all 0.2s;
}

.LandingPageV4_footerSocial__OIJVr a:hover {
  color: white;
  border-color: #4f91f7;
  background: #0a64f9;
}

.LandingPageV4_footerCopyright__kSRQs {
  font-size: 12px;
  color: #8fa6c1;
  font-weight: 500;
  margin: 0;
}

.LandingPageV4_footerBadges__040Ap {
  display: flex;
  gap: 18px;
}

.LandingPageV4_footerBadge__ltsp9 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 900;
  color: #9db1ca;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* Focus states for accessibility */
.LandingPageV4_orderCardBtnPrimary__W22cs:focus-visible,
.LandingPageV4_orderCardBtnOutline__HB1Yo:focus-visible,
.LandingPageV4_partnerGlassBtn__n1\\+62:focus-visible,
.LandingPageV4_newsletterBtn__kYFon:focus-visible,
.LandingPageV4_categoryArrow__8sgtP:focus-visible,
.LandingPageV4_categoryPill__bHh52:focus-visible,
.LandingPageV4_logoButton__qGn\\+B:focus-visible,
.LandingPageV4_signInBtn__IPzgy:focus-visible,
.LandingPageV4_signUpBtn__VZWBW:focus-visible,
.LandingPageV4_profileBtn__w0iq8:focus-visible,
.LandingPageV4_menuItemBtn__7jVDt:focus-visible,
.LandingPageV4_logoutBtn__HHe98:focus-visible {
  outline: 2px solid #0052ff;
  outline-offset: 2px;
}

.LandingPageV4_footerSocial__OIJVr a:focus-visible {
  outline: 2px solid #0052ff;
  outline-offset: 2px;
}

.LandingPageV4_footerBrand__ol-2d > a:focus-visible {
  width: fit-content;
  outline: 2px solid #0052ff;
  outline-offset: 4px;
}

.LandingPageV4_header__7wrpI .LandingPageV4_logoButton__qGn\\+B:focus-visible,
.LandingPageV4_header__7wrpI .LandingPageV4_signInBtn__IPzgy:focus-visible,
.LandingPageV4_header__7wrpI .LandingPageV4_signUpBtn__VZWBW:focus-visible,
.LandingPageV4_header__7wrpI .LandingPageV4_profileBtn__w0iq8:focus-visible {
  outline-color: #8bb8ff;
}

/* ===== Responsive ===== */
@media (max-width: 1200px) {
  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding: 0 24px;
  }

}

@media (max-width: 992px) {
  .LandingPageV4_orderOptionsGrid__gtton {
    grid-template-columns: 1fr;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 450px;
  }

  .LandingPageV4_contentSection__moDt4 {
    flex-direction: column;
    gap: 32px;
  }

  .LandingPageV4_contentSectionReverse__pZZif {
    flex-direction: column;
  }

  .LandingPageV4_footerGrid__QMMCm {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 32px;
  }

  .LandingPageV4_footerBrand__ol-2d {
    grid-column: span 2;
  }

  .LandingPageV4_trustBarGrid__S56x- {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .LandingPageV4_trustItem__NkSuB {
    justify-content: flex-start;
    border-right: none;
    padding: 0;
  }

  .LandingPageV4_categoryHeader__bAQgF {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .LandingPageV4_heroViewport__rSy59 {
    min-height: calc(100vh - 60px);
    min-height: calc(100dvh - 60px);
  }

  .LandingPageV4_innerWrapper__jP322 {
    padding: 0 20px;
  }

  .LandingPageV4_header__7wrpI {
    height: 60px;
  }

  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding: 0 16px;
    gap: 12px;
  }

  .LandingPageV4_logo__OsjVE {
    width: clamp(96px, 20vw, 116px);
    height: auto;
  }

  .LandingPageV4_headerButtons__d7rrc {
    gap: 7px;
  }

  .LandingPageV4_signInBtn__IPzgy {
    min-height: 42px;
    padding: 0 12px;
    font-size: 13px;
    gap: 6px;
  }

  .LandingPageV4_signUpBtn__VZWBW {
    min-height: 42px;
    padding: 0 14px;
    font-size: 13px;
  }

  .LandingPageV4_profileBtn__w0iq8 {
    width: 42px;
    height: 42px;
  }

  .LandingPageV4_profileMenu__\\+Xzo\\+ {
    width: min(288px, calc(100vw - 24px));
    max-height: calc(100dvh - 76px);
    overflow-y: auto;
  }

  .LandingPageV4_trustBar__oHfgX {
    margin-top: -40px;
    padding: 0 16px;
  }

  .LandingPageV4_trustBarCard__C43QQ {
    padding: 24px;
  }

  .LandingPageV4_trustText__jxtdf {
    font-size: 20px;
  }

  .LandingPageV4_sectionTitle__q9iWx {
    font-size: 28px;
  }

  .LandingPageV4_sectionSubtitle__tWkjP {
    font-size: 15px;
  }

  .LandingPageV4_orderOptions__onirQ {
    padding: 56px 0;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 380px;
  }

  .LandingPageV4_orderCardContentOverlay__sJmUk {
    padding: 24px;
  }

  .LandingPageV4_orderCardTitle__9Wrq3 {
    font-size: 28px;
  }

  .LandingPageV4_orderCardText__3Kb9a {
    font-size: 15px;
    margin-bottom: 0;
    padding-bottom: 16px;
  }

  .LandingPageV4_categoryStrip__Ud\\+Yg {
    padding: 40px 0;
  }

  .LandingPageV4_categoryTitle__BXOKV {
    font-size: 24px;
  }

  .LandingPageV4_categoryNavButtons__fT4BV {
    display: none;
  }

  .LandingPageV4_categoryFadeLeft__x63YP,
  .LandingPageV4_categoryFadeRight__XERjO {
    display: none;
  }

  .LandingPageV4_categoryPill__bHh52 {
    width: 130px;
    padding: 16px;
    min-height: 120px;
  }

  .LandingPageV4_categoryIconContainer__GB8mM {
    width: 64px;
    height: 64px;
    font-size: 28px;
  }

  .LandingPageV4_newsletter__DV3bX {
    padding: 34px 0 30px;
  }

  .LandingPageV4_newsletterTitle__OMI9U {
    font-size: 27px;
  }

  .LandingPageV4_newsletterForm__SlMqm {
    flex-direction: column;
  }

  .LandingPageV4_newsletterBtn__kYFon {
    width: 100%;
  }

  .LandingPageV4_newsletterSubtitle__-kL1i {
    margin-bottom: 16px;
  }

  .LandingPageV4_footerGrid__QMMCm {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 20px;
    margin-bottom: 18px;
  }

  .LandingPageV4_footerBrand__ol-2d {
    grid-column: span 2;
  }

  .LandingPageV4_footerBottom__L6WSo {
    flex-direction: column;
    gap: 10px;
    min-height: 0;
    padding: 14px 0 16px;
    text-align: center;
  }

  .LandingPageV4_footerBadges__040Ap {
    flex-flow: row wrap;
    justify-content: center;
    gap: 8px 14px;
    align-items: center;
  }

  .LandingPageV4_footer__\\+l-US {
    padding: 28px 0 0;
  }

  .LandingPageV4_footerColumn__cTUqZ a {
    min-height: 40px;
  }

  .LandingPageV4_footerHelpText__GsrfR {
    max-width: 420px;
  }

  .LandingPageV4_footerContactLink__is6TE {
    min-height: 44px;
  }
}

@media (max-width: 480px) {
  .LandingPageV4_categoryPills__kiyYa {
    gap: 12px;
  }

  .LandingPageV4_categoryPill__bHh52 {
    width: 116px;
    min-height: 114px;
    padding: 14px 10px;
  }

  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding: 0 10px;
    gap: 8px;
  }

  .LandingPageV4_logo__OsjVE {
    width: 98px;
  }

  .LandingPageV4_logoButton__qGn\\+B {
    min-height: 44px;
  }

  .LandingPageV4_headerButtons__d7rrc {
    gap: 6px;
  }

  .LandingPageV4_signInBtn__IPzgy {
    min-height: 44px;
    padding: 0 8px;
    gap: 4px;
    font-size: 12px;
  }

  .LandingPageV4_signUpBtn__VZWBW {
    min-height: 44px;
    padding: 0 10px;
    font-size: 12px;
  }

  .LandingPageV4_profileBtn__w0iq8 {
    width: 44px;
    height: 44px;
  }

  .LandingPageV4_trustBarGrid__S56x- {
    grid-template-columns: 1fr 1fr;
    gap: 14px 8px;
  }

  .LandingPageV4_trustBarCard__C43QQ {
    padding: 18px 16px;
  }

  .LandingPageV4_trustItem__NkSuB {
    gap: 8px;
  }

  .LandingPageV4_trustIcon__-ANnJ {
    width: 38px;
    height: 38px;
  }

  .LandingPageV4_trustText__jxtdf {
    font-size: 16px;
  }

  .LandingPageV4_trustSubtext__TKs1m {
    font-size: 8px;
    letter-spacing: 0.05em;
    overflow-wrap: anywhere;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 320px;
  }

  .LandingPageV4_orderCardTitle__9Wrq3 {
    font-size: 24px;
  }
}

@media (max-width: 600px) {
  .LandingPageV4_footerGrid__QMMCm {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .LandingPageV4_footerBrand__ol-2d {
    grid-column: span 2;
  }

  .LandingPageV4_footerGrid__QMMCm > .LandingPageV4_footerColumn__cTUqZ:nth-child(4),
  .LandingPageV4_footerGrid__QMMCm > .LandingPageV4_footerColumn__cTUqZ:last-child {
    grid-column: span 2;
  }

  .LandingPageV4_footerGrid__QMMCm > .LandingPageV4_footerColumn__cTUqZ:nth-child(4) ul {
    display: flex;
    flex-wrap: wrap;
    column-gap: 18px;
  }

}

@media (min-width: 601px) and (max-width: 992px) {
  .LandingPageV4_footerGrid__QMMCm {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 20px;
  }

  .LandingPageV4_footerGrid__QMMCm > .LandingPageV4_footerColumn__cTUqZ:last-child {
    grid-column: span 3;
  }
}

@media (min-width: 360px) and (max-width: 768px) {
  .LandingPageV4_newsletterForm__SlMqm {
    flex-direction: row;
    gap: 8px;
  }

  .LandingPageV4_newsletterInput__FNmSs {
    padding-right: 14px;
    padding-left: 14px;
  }

  .LandingPageV4_newsletterBtn__kYFon {
    width: auto;
    padding-right: 18px;
    padding-left: 18px;
  }
}

@media (max-width: 359px) {
  .LandingPageV4_innerWrapper__jP322 {
    padding-right: 14px;
    padding-left: 14px;
  }

  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding-right: 8px;
    padding-left: 8px;
  }

  .LandingPageV4_logo__OsjVE {
    width: 82px;
  }

  .LandingPageV4_signInBtn__IPzgy {
    padding-right: 7px;
    padding-left: 7px;
  }

  .LandingPageV4_signUpBtn__VZWBW {
    padding-right: 9px;
    padding-left: 9px;
  }

  .LandingPageV4_newsletter__DV3bX {
    padding: 30px 0 26px;
  }

  .LandingPageV4_newsletterTitle__OMI9U {
    font-size: 25px;
  }

  .LandingPageV4_footerGrid__QMMCm {
    column-gap: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .LandingPageV4_pageWrapper__nkocj *,
  .LandingPageV4_pageWrapper__nkocj *::before,
  .LandingPageV4_pageWrapper__nkocj *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* ===== Landing experience refinement ===== */
.LandingPageV4_pageWrapper__nkocj {
  overflow-x: clip;
  color: #0b1c30;
}

.LandingPageV4_heroViewport__rSy59 {
  min-height: 0;
}

.LandingPageV4_sectionEyebrow__PSy7g {
  margin: 0 0 10px;
  color: #0a64f9;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.13em;
  line-height: 18px;
  text-transform: uppercase;
}

.LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) auto minmax(160px, 1fr);
}

.LandingPageV4_logoButton__qGn\\+B {
  justify-self: start;
}

.LandingPageV4_headerNav__U19t6 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.LandingPageV4_headerNavLink__wSFHb {
  min-height: 40px;
  padding: 0 13px;
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #bdcde0;
  font-size: 13px;
  font-weight: 720;
  line-height: 20px;
  text-decoration: none;
  white-space: nowrap;
  transition:
    color 160ms ease,
    border-color 160ms ease,
    background 160ms ease;
}

.LandingPageV4_headerNavLink__wSFHb:hover {
  border-color: rgba(151, 183, 221, 0.18);
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.LandingPageV4_headerButtons__d7rrc {
  justify-self: end;
}

.LandingPageV4_trustBar__oHfgX {
  margin-top: -48px;
  margin-bottom: 0;
}

.LandingPageV4_trustBarCard__C43QQ {
  padding: 25px 34px;
  border: 1px solid rgba(211, 224, 240, 0.85);
  background:
    radial-gradient(circle at 8% 20%, rgba(10, 100, 249, 0.07), transparent 24%),
    rgba(255, 255, 255, 0.97);
  box-shadow:
    0 24px 60px rgba(19, 54, 101, 0.1),
    0 2px 8px rgba(19, 54, 101, 0.05);
  backdrop-filter: blur(16px);
}

.LandingPageV4_trustIcon__-ANnJ {
  width: 44px;
  height: 44px;
  background: linear-gradient(145deg, #edf5ff, #dceaff);
}

.LandingPageV4_trustText__jxtdf {
  font-size: 22px;
}

.LandingPageV4_trustSubtext__TKs1m {
  font-size: 10px;
}

.LandingPageV4_categoryStrip__Ud\\+Yg {
  padding: 70px 0 62px;
  scroll-margin-top: 72px;
  background:
    radial-gradient(circle at 100% 0, rgba(10, 100, 249, 0.06), transparent 30%),
    #fff;
}

.LandingPageV4_categoryHeader__bAQgF {
  margin-bottom: 22px;
  align-items: flex-end;
}

.LandingPageV4_categoryTitle__BXOKV {
  margin: 0;
  color: #081d38;
  font-size: clamp(30px, 3.4vw, 44px);
  font-weight: 880;
  letter-spacing: -0.045em;
  line-height: 1.06;
}

.LandingPageV4_categoryDescription__Dd9uU {
  max-width: 590px;
  margin: 12px 0 0;
  color: #64748b;
  font-size: 15px;
  line-height: 1.65;
}

.LandingPageV4_categoryNavButtons__fT4BV {
  gap: 10px;
}

.LandingPageV4_categoryArrow__8sgtP {
  width: 48px;
  height: 48px;
  border-color: #dbe5f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 7px 20px rgba(21, 52, 92, 0.06);
}

.LandingPageV4_categoryArrow__8sgtP:hover:not(:disabled) {
  border-color: #8bb8ff;
  background: #edf5ff;
  box-shadow: 0 9px 24px rgba(10, 100, 249, 0.13);
  transform: translateY(-2px);
}

.LandingPageV4_categorySwipeHint__yuT7O {
  display: none;
}

.LandingPageV4_categoryPills__kiyYa {
  gap: 14px;
  padding: 7px 4px 13px;
  scroll-padding-inline: 4px;
}

.LandingPageV4_categoryPill__bHh52 {
  position: relative;
  width: 150px;
  min-height: 154px;
  padding: 17px 14px 18px;
  gap: 10px;
  overflow: hidden;
  border: 1px solid #e1eaf5;
  border-radius: 22px;
  background:
    linear-gradient(150deg, rgba(242, 247, 255, 0.68), transparent 42%),
    #fff;
  box-shadow:
    0 12px 28px rgba(25, 56, 96, 0.06),
    0 1px 3px rgba(25, 56, 96, 0.04);
  transition:
    border-color 220ms ease,
    box-shadow 220ms ease,
    transform 220ms ease;
}

.LandingPageV4_categoryPill__bHh52::before {
  position: absolute;
  inset: auto -28px -40px auto;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  background: rgba(10, 100, 249, 0.055);
  content: '';
  transition: transform 220ms ease;
}

.LandingPageV4_categoryPill__bHh52:hover {
  border-color: #bdd6fa;
  box-shadow:
    0 18px 36px rgba(10, 100, 249, 0.12),
    0 2px 5px rgba(25, 56, 96, 0.05);
  transform: translateY(-4px);
}

.LandingPageV4_categoryPill__bHh52:hover::before {
  transform: scale(1.25);
}

.LandingPageV4_categoryIconContainer__GB8mM {
  width: 68px;
  height: 68px;
  border-radius: 19px;
  background: linear-gradient(145deg, #eef5ff, #dceaff);
  box-shadow: inset 0 0 0 1px rgba(10, 100, 249, 0.06);
  color: #0a58d3;
}

.LandingPageV4_categoryPill__bHh52:hover .LandingPageV4_categoryIconContainer__GB8mM {
  background: linear-gradient(145deg, #1474ff, #0755d8);
  box-shadow: 0 10px 22px rgba(10, 100, 249, 0.22);
  transform: translateY(-1px) rotate(-2deg);
}

.LandingPageV4_categoryPillLabel__sFpNE {
  position: relative;
  z-index: 1;
  max-width: 100%;
  color: #142b48;
  font-size: 13px;
  font-weight: 780;
  line-height: 18px;
  text-wrap: balance;
}

.LandingPageV4_categoryPillArrow__FSSta {
  position: absolute;
  z-index: 1;
  top: 12px;
  right: 12px;
  color: #9aabc0;
  transition:
    color 180ms ease,
    transform 180ms ease;
}

.LandingPageV4_categoryPill__bHh52:hover .LandingPageV4_categoryPillArrow__FSSta {
  color: #0a64f9;
  transform: translate(2px, -2px);
}

.LandingPageV4_categoryIconLoader__JwIy- {
  animation: LandingPageV4_spin__hGHqY 0.9s linear infinite;
}

.LandingPageV4_howSection__ugMj8 {
  padding: 70px 0 76px;
  scroll-margin-top: 72px;
  background:
    linear-gradient(rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.52)),
    radial-gradient(circle at 12% 20%, rgba(10, 100, 249, 0.12), transparent 30%),
    #eef4fc;
  border-top: 1px solid #e3ebf5;
  border-bottom: 1px solid #dfe9f4;
}

.LandingPageV4_howHeader__n4mVJ {
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.7fr);
  align-items: end;
  gap: 64px;
}

.LandingPageV4_howTitle__BVSru {
  max-width: 720px;
  margin: 0;
  color: #071c38;
  font-size: clamp(34px, 4.2vw, 54px);
  font-weight: 890;
  letter-spacing: -0.052em;
  line-height: 1.02;
  text-wrap: balance;
}

.LandingPageV4_howDescription__UUE\\+x {
  margin: 0 0 3px;
  color: #5e7087;
  font-size: 15px;
  font-weight: 540;
  line-height: 1.7;
}

.LandingPageV4_howGrid__QU9Qg {
  position: relative;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  list-style: none;
  counter-reset: landing-step;
}

.LandingPageV4_howCard__swxRV {
  position: relative;
  min-width: 0;
  min-height: 214px;
  padding: 24px 24px 22px;
  overflow: hidden;
  border: 1px solid #dce7f3;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.91);
  box-shadow: 0 16px 42px rgba(27, 60, 101, 0.07);
  list-style: none;
  transition:
    border-color 220ms ease,
    box-shadow 220ms ease,
    transform 220ms ease;
}

.LandingPageV4_howCard__swxRV::after {
  content: none;
}

.LandingPageV4_howCard__swxRV:hover {
  border-color: #bcd4f6;
  box-shadow: 0 22px 48px rgba(10, 78, 178, 0.11);
  transform: translateY(-4px);
}

.LandingPageV4_howCardTop__rW2Z6 {
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.LandingPageV4_howStep__gZ\\+BZ {
  color: #8da0b7;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.LandingPageV4_howIcon__g42Dy {
  width: 50px;
  height: 50px;
  display: grid;
  place-items: center;
  border-radius: 15px;
  background: linear-gradient(145deg, #126eff, #0751cc);
  box-shadow: 0 10px 24px rgba(8, 83, 209, 0.22);
  color: #fff;
}

.LandingPageV4_howCardTitle__r94bk {
  position: relative;
  z-index: 1;
  margin: 0 0 10px;
  color: #102843;
  font-size: 20px;
  font-weight: 830;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.LandingPageV4_howCardText__gyld6 {
  position: relative;
  z-index: 1;
  max-width: 340px;
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.65;
}

.LandingPageV4_orderOptions__onirQ {
  padding: 70px 0 76px;
  background:
    radial-gradient(circle at 94% 0, rgba(19, 113, 255, 0.22), transparent 32%),
    radial-gradient(circle at 0 100%, rgba(24, 85, 169, 0.18), transparent 30%),
    #071c37;
}

.LandingPageV4_orderOptionsHeader__eEHlu {
  margin-bottom: 32px;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.65fr);
  align-items: end;
  gap: 64px;
  text-align: left;
}

.LandingPageV4_orderOptions__onirQ .LandingPageV4_sectionEyebrow__PSy7g {
  color: #75adff;
}

.LandingPageV4_sectionTitle__q9iWx {
  max-width: 720px;
  margin: 0;
  color: #fff;
  font-size: clamp(34px, 4.2vw, 54px);
  font-weight: 890;
  letter-spacing: -0.052em;
  line-height: 1.02;
  text-wrap: balance;
}

.LandingPageV4_sectionSubtitle__tWkjP {
  max-width: 460px;
  margin: 0 0 3px;
  color: #b5c5d9;
  font-size: 15px;
  line-height: 1.7;
}

.LandingPageV4_orderOptionsGrid__gtton {
  gap: 20px;
}

.LandingPageV4_orderCard__cl6WT {
  height: clamp(400px, 31vw, 440px);
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 28px;
  background: #102744;
  box-shadow: 0 22px 50px rgba(0, 8, 24, 0.24);
}

.LandingPageV4_orderCardImageFull__dETSC {
  filter: saturate(0.9) contrast(1.02);
}

.LandingPageV4_orderCardOverlay__Lc2fS {
  background:
    linear-gradient(to top, rgba(2, 14, 31, 0.96) 0%, rgba(3, 19, 41, 0.7) 47%, rgba(3, 19, 41, 0.12) 78%),
    linear-gradient(110deg, rgba(5, 25, 52, 0.34), transparent 55%);
}

.LandingPageV4_orderCardContentOverlay__sJmUk {
  padding: 30px;
}

.LandingPageV4_orderCardTopline__aFUmW {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.LandingPageV4_orderCardNumber__iDaQx {
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.14em;
}

.LandingPageV4_orderCardMode__O\\+AyS {
  min-height: 30px;
  padding: 5px 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  background: rgba(7, 28, 55, 0.46);
  color: #dce8f8;
  font-size: 10px;
  font-weight: 760;
  letter-spacing: 0.02em;
  backdrop-filter: blur(10px);
}

.LandingPageV4_orderCardBadge__ONFKd {
  margin-bottom: 13px;
  background: #0a64f9;
}

.LandingPageV4_orderCardTitle__9Wrq3 {
  margin: 0 0 10px;
  font-size: clamp(31px, 3.2vw, 43px);
  line-height: 1.04;
}

.LandingPageV4_orderCardText__3Kb9a {
  max-width: 450px;
  padding-bottom: 18px;
  color: #d1deee;
  font-size: 15px;
  line-height: 1.6;
}

.LandingPageV4_orderCardBtnPrimary__W22cs,
.LandingPageV4_orderCardBtnOutline__HB1Yo {
  min-height: 50px;
  padding: 0 20px;
  border: 1px solid rgba(255, 255, 255, 0.84);
  border-radius: 13px;
  font-size: 14px;
  font-weight: 790;
  transition:
    background 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.LandingPageV4_orderCardBtnPrimary__W22cs:hover,
.LandingPageV4_orderCardBtnOutline__HB1Yo:hover {
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.19);
  transform: translateY(-2px);
}

.LandingPageV4_orderCardBtnPrimary__W22cs svg,
.LandingPageV4_orderCardBtnOutline__HB1Yo svg,
.LandingPageV4_partnerGlassBtn__n1\\+62 svg {
  transition: transform 180ms ease;
}

.LandingPageV4_orderCardBtnPrimary__W22cs:hover svg,
.LandingPageV4_orderCardBtnOutline__HB1Yo:hover svg,
.LandingPageV4_partnerGlassBtn__n1\\+62:hover svg {
  transform: translateX(3px);
}

.LandingPageV4_partnerSection__dGi7F {
  padding: clamp(42px, 4.8vw, 58px) 0;
  scroll-margin-top: 72px;
  background:
    radial-gradient(circle at 7% 8%, rgba(10, 100, 249, 0.1), transparent 27%),
    radial-gradient(circle at 94% 92%, rgba(77, 97, 255, 0.07), transparent 24%),
    linear-gradient(180deg, #f7faff 0%, #f2f7fd 100%);
}

.LandingPageV4_partnerCard__arAP1 {
  position: relative;
  min-height: 548px;
  padding: 42px 40px 42px 50px;
  display: grid;
  grid-template-columns: minmax(0, 0.86fr) minmax(0, 1.14fr);
  align-items: center;
  gap: clamp(30px, 3.6vw, 54px);
  overflow: hidden;
  isolation: isolate;
  border: 1px solid rgba(132, 187, 255, 0.25);
  border-radius: 36px;
  background:
    radial-gradient(circle at 78% 46%, rgba(24, 116, 255, 0.2), transparent 31%),
    radial-gradient(circle at 10% 112%, rgba(72, 101, 255, 0.3), transparent 43%),
    linear-gradient(
      110deg,
      #123f79 0%,
      #082b58 38%,
      #030c1c 56%,
      #01050c 75%,
      #000000 100%
    );
  box-shadow:
    0 30px 76px rgba(4, 33, 78, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
  text-align: left;
}

.LandingPageV4_partnerCard__arAP1::before {
  position: absolute;
  z-index: 0;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(6, 38, 83, 0.08), rgba(0, 0, 0, 0.14)),
    linear-gradient(rgba(119, 177, 255, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(119, 177, 255, 0.055) 1px, transparent 1px),
    radial-gradient(circle at 88% 18%, rgba(64, 151, 255, 0.16), transparent 26%);
  background-size: auto, 40px 40px, 40px 40px, auto;
  mask-image: linear-gradient(90deg, transparent 32%, #000000 64%);
  content: '';
  pointer-events: none;
}

.LandingPageV4_partnerCardContent__PJG6c {
  position: relative;
  min-width: 0;
  z-index: 3;
  align-self: center;
}

.LandingPageV4_partnerEyebrow__RY\\+c3 {
  width: fit-content;
  margin: 0 0 13px;
  padding: 7px 12px;
  border: 1px solid rgba(132, 189, 255, 0.34);
  border-radius: 999px;
  background: rgba(15, 102, 224, 0.23);
  color: #ffffff;
  font-size: 10px;
  font-weight: 820;
  letter-spacing: 0.1em;
  line-height: 17px;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
}

.LandingPageV4_partnerTitle__lXaxl {
  max-width: 590px;
  margin: 0 0 14px;
  color: #ffffff;
  font-size: clamp(39px, 3.75vw, 49px);
  letter-spacing: -0.052em;
  line-height: 1.02;
  text-wrap: balance;
}

.LandingPageV4_partnerDescription__TKVul {
  max-width: 500px;
  padding: 0;
  margin: 0 0 18px;
  color: #d7e8ff;
  font-size: 15.5px;
  font-weight: 540;
  line-height: 1.62;
}

.LandingPageV4_partnerFeatureList__s-SXi {
  margin: 0 0 22px;
  padding: 0;
  display: flex;
  flex-flow: row wrap;
  gap: 9px;
  list-style: none;
}

.LandingPageV4_partnerFeatureList__s-SXi li {
  min-height: 38px;
  padding: 7px 11px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(133, 186, 255, 0.27);
  border-radius: 12px;
  background: rgba(8, 45, 95, 0.62);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  color: #ffffff;
  font-size: 11px;
  font-weight: 720;
  white-space: nowrap;
}

.LandingPageV4_partnerFeatureList__s-SXi svg {
  color: #8fc0ff;
}

.LandingPageV4_partnerGlassBtn__n1\\+62 {
  min-height: 48px;
  padding: 0 20px;
  border-color: #ffffff;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
  color: #0758dd;
  font-size: 14px;
  font-weight: 800;
}

.LandingPageV4_partnerGlassBtn__n1\\+62:hover {
  background: #eef6ff;
  box-shadow: 0 15px 34px rgba(0, 0, 0, 0.24);
}

.LandingPageV4_partnerExperience__t4iqF {
  position: relative;
  z-index: 2;
  width: min(100%, 700px);
  margin: 0;
  padding: 0;
  min-width: 0;
  align-self: center;
  justify-self: end;
  isolation: isolate;
}

.LandingPageV4_partnerExperience__t4iqF::before {
  position: absolute;
  z-index: -1;
  top: 7%;
  right: -6%;
  bottom: 7%;
  left: 8%;
  border: 1px solid rgba(86, 158, 255, 0.12);
  border-radius: 30px;
  background: linear-gradient(
    135deg,
    rgba(27, 110, 235, 0.12),
    rgba(37, 52, 104, 0.02)
  );
  content: '';
  pointer-events: none;
  transform: rotate(2.2deg);
}

.LandingPageV4_newsletter__DV3bX {
  padding: 44px 0;
  background: #fff;
  text-align: left;
}

.LandingPageV4_newsletterCard__bdoK- {
  padding: 31px 34px;
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1.1fr);
  align-items: center;
  gap: clamp(34px, 6vw, 86px);
  border: 1px solid #dce6f2;
  border-radius: 24px;
  background:
    radial-gradient(circle at 0 0, rgba(10, 100, 249, 0.09), transparent 35%),
    linear-gradient(145deg, #fbfdff, #f1f6fd);
  box-shadow: 0 15px 42px rgba(21, 54, 96, 0.07);
}

.LandingPageV4_newsletterIntro__KMmr5 {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.LandingPageV4_newsletterIcon__W7t8k {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  flex: 0 0 46px;
  border-radius: 14px;
  background: linear-gradient(145deg, #1474ff, #0754d4);
  box-shadow: 0 10px 23px rgba(8, 82, 207, 0.2);
  color: #fff;
}

.LandingPageV4_newsletterTitle__OMI9U {
  margin: 1px 0 6px;
  font-size: clamp(24px, 2.35vw, 31px);
  line-height: 1.1;
}

.LandingPageV4_newsletterSubtitle__-kL1i {
  max-width: 480px;
  margin: 0;
  color: #5d7088;
  font-size: 14px;
  line-height: 1.55;
}

.LandingPageV4_newsletterSignup__Mv7Mn {
  min-width: 0;
  align-items: stretch;
}

.LandingPageV4_newsletterFormWrapper__DXthJ {
  min-width: 0;
  max-width: none;
  margin: 0;
}

.LandingPageV4_newsletterForm__SlMqm {
  position: relative;
  min-width: 0;
  gap: 9px;
}

.LandingPageV4_newsletterInputIcon__DxKI9 {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 16px;
  display: grid;
  place-items: center;
  color: #708299;
  transform: translateY(-50%);
  pointer-events: none;
}

.LandingPageV4_newsletterInput__FNmSs {
  min-height: 54px;
  padding: 0 16px 0 45px;
  border-color: #cedbea !important;
  background: #fff !important;
  font-size: 14px;
}

.LandingPageV4_newsletterInput__FNmSs:focus {
  box-shadow: 0 0 0 4px rgba(10, 100, 249, 0.1);
}

.LandingPageV4_newsletterBtn__kYFon {
  min-height: 54px;
  padding: 0 22px;
  font-size: 14px;
}

.LandingPageV4_newsletterTerms__wLreU {
  margin: 9px 0 0;
  color: #64748b;
  font-size: 11px;
}

.LandingPageV4_newsletterTerms__wLreU a {
  color: #315f9d;
  font-weight: 700;
  text-underline-offset: 2px;
}

.LandingPageV4_visuallyHidden__EJxvK {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.LandingPageV4_footer__\\+l-US {
  padding-top: 27px;
}

.LandingPageV4_footerGrid__QMMCm {
  margin-bottom: 16px;
}

.LandingPageV4_footerContactLink__is6TE svg {
  flex: 0 0 auto;
  color: #75adff;
}

.LandingPageV4_headerNavLink__wSFHb:focus-visible,
.LandingPageV4_newsletterTerms__wLreU a:focus-visible {
  outline: 2px solid #75adff;
  outline-offset: 3px;
  border-radius: 4px;
}

@media (max-width: 1080px) {
  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    grid-template-columns: minmax(140px, 1fr) auto minmax(140px, 1fr);
  }

  .LandingPageV4_headerNavLink__wSFHb {
    padding-right: 9px;
    padding-left: 9px;
    font-size: 12px;
  }

  .LandingPageV4_howHeader__n4mVJ,
  .LandingPageV4_orderOptionsHeader__eEHlu {
    gap: 36px;
  }

  .LandingPageV4_partnerCard__arAP1 {
    padding: 39px 32px 39px 40px;
    grid-template-columns: minmax(0, 0.84fr) minmax(0, 1.16fr);
    gap: 28px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(37px, 4.1vw, 47px);
  }

  .LandingPageV4_partnerExperience__t4iqF {
    margin: 0;
    padding: 0;
  }

  .LandingPageV4_newsletterCard__bdoK- {
    grid-template-columns: minmax(0, 0.9fr) minmax(380px, 1.1fr);
    gap: 32px;
  }
}

@media (max-width: 900px) {
  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    display: flex;
  }

  .LandingPageV4_headerNav__U19t6 {
    display: none;
  }

  .LandingPageV4_howHeader__n4mVJ,
  .LandingPageV4_orderOptionsHeader__eEHlu {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .LandingPageV4_howDescription__UUE\\+x,
  .LandingPageV4_sectionSubtitle__tWkjP {
    max-width: 640px;
  }

  .LandingPageV4_howGrid__QU9Qg {
    grid-template-columns: 1fr;
  }

  .LandingPageV4_howCard__swxRV {
    min-height: 0;
  }

  .LandingPageV4_howCardTop__rW2Z6 {
    margin-bottom: 22px;
  }

  .LandingPageV4_partnerCard__arAP1 {
    min-height: 0;
    padding: 42px 40px 38px;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
    background:
      radial-gradient(circle at 70% 64%, rgba(13, 111, 255, 0.16), transparent 32%),
      radial-gradient(circle at 10% 25%, rgba(76, 108, 255, 0.2), transparent 36%),
      linear-gradient(
        180deg,
        #103e79 0%,
        #082b59 45%,
        #010813 59%,
        #000000 70%,
        #000000 100%
      );
    text-align: left;
  }

  .LandingPageV4_partnerCardContent__PJG6c {
    max-width: 680px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    max-width: 670px;
  }

  .LandingPageV4_partnerDescription__TKVul {
    max-width: 620px;
    margin-right: 0;
    margin-left: 0;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: min(100%, 720px);
    margin-right: 0;
    padding: 0;
    justify-self: center;
  }

  .LandingPageV4_partnerExperience__t4iqF::before {
    top: 9%;
    right: -3%;
    bottom: 9%;
    left: 5%;
  }

  .LandingPageV4_newsletterCard__bdoK- {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .LandingPageV4_heroViewport__rSy59 {
    min-height: 0;
  }

  .LandingPageV4_trustBar__oHfgX {
    margin-top: -31px;
    padding: 0 16px;
  }

  .LandingPageV4_trustBarCard__C43QQ {
    padding: 18px 17px;
    border-radius: 18px;
  }

  .LandingPageV4_trustBarGrid__S56x- {
    gap: 16px 10px;
  }

  .LandingPageV4_trustItem__NkSuB {
    gap: 9px;
  }

  .LandingPageV4_trustIcon__-ANnJ {
    width: 38px;
    height: 38px;
  }

  .LandingPageV4_trustIcon__-ANnJ svg {
    width: 20px;
    height: 20px;
  }

  .LandingPageV4_trustText__jxtdf {
    font-size: 17px;
  }

  .LandingPageV4_trustSubtext__TKs1m {
    font-size: 9.5px;
    line-height: 1.25;
  }

  .LandingPageV4_categoryStrip__Ud\\+Yg {
    padding: 48px 0 44px;
  }

  .LandingPageV4_categoryHeader__bAQgF {
    margin-bottom: 13px;
  }

  .LandingPageV4_categoryTitle__BXOKV {
    font-size: clamp(29px, 8vw, 37px);
  }

  .LandingPageV4_categoryDescription__Dd9uU {
    margin-top: 9px;
    font-size: 14px;
  }

  .LandingPageV4_categorySwipeHint__yuT7O {
    min-height: 27px;
    margin: 0 0 8px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #6f8198;
    font-size: 10px;
    font-weight: 760;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .LandingPageV4_categoryScrollWrapper__O5aqT {
    margin-right: -20px;
  }

  .LandingPageV4_categoryPills__kiyYa {
    gap: 11px;
    padding-right: 20px;
    padding-bottom: 11px;
  }

  .LandingPageV4_categoryPill__bHh52 {
    width: clamp(120px, 38vw, 136px);
    min-height: 130px;
    padding: 13px 10px;
    border-radius: 19px;
  }

  .LandingPageV4_categoryIconContainer__GB8mM {
    width: 61px;
    height: 61px;
    border-radius: 17px;
  }

  .LandingPageV4_categoryIconContainer__GB8mM svg {
    width: 28px;
    height: 28px;
  }

  .LandingPageV4_howSection__ugMj8 {
    padding: 48px 0 52px;
  }

  .LandingPageV4_howHeader__n4mVJ {
    margin-bottom: 22px;
  }

  .LandingPageV4_howTitle__BVSru,
  .LandingPageV4_sectionTitle__q9iWx {
    font-size: clamp(31px, 8.5vw, 42px);
  }

  .LandingPageV4_howDescription__UUE\\+x,
  .LandingPageV4_sectionSubtitle__tWkjP {
    font-size: 14px;
    line-height: 1.6;
  }

  .LandingPageV4_howGrid__QU9Qg {
    gap: 12px;
  }

  .LandingPageV4_howCard__swxRV {
    padding: 19px 20px;
    border-radius: 20px;
  }

  .LandingPageV4_howCardTop__rW2Z6 {
    margin-bottom: 14px;
  }

  .LandingPageV4_howIcon__g42Dy {
    width: 43px;
    height: 43px;
  }

  .LandingPageV4_orderOptions__onirQ {
    padding: 50px 0 54px;
  }

  .LandingPageV4_orderOptionsHeader__eEHlu {
    margin-bottom: 23px;
  }

  .LandingPageV4_orderOptionsGrid__gtton {
    gap: 12px;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 340px;
    border-radius: 23px;
  }

  .LandingPageV4_orderCardContentOverlay__sJmUk {
    padding: 21px;
  }

  .LandingPageV4_orderCardTopline__aFUmW {
    margin-bottom: 11px;
  }

  .LandingPageV4_orderCardTitle__9Wrq3 {
    font-size: 30px;
  }

  .LandingPageV4_orderCardText__3Kb9a {
    padding-bottom: 13px;
  }

  .LandingPageV4_partnerSection__dGi7F {
    padding: 44px 0;
  }

  .LandingPageV4_partnerCard__arAP1 {
    min-height: 0;
    padding: 34px 29px 29px;
    gap: 24px;
    border-radius: 28px;
  }

  .LandingPageV4_partnerCardContent__PJG6c {
    max-width: 100%;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(35px, 8vw, 46px);
  }

  .LandingPageV4_partnerFeatureList__s-SXi {
    max-width: 510px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }

  .LandingPageV4_newsletter__DV3bX {
    padding: 32px 0;
  }

  .LandingPageV4_newsletterCard__bdoK- {
    padding: 26px;
    gap: 22px;
    border-radius: 21px;
  }

  .LandingPageV4_newsletterIntro__KMmr5 {
    gap: 12px;
  }

  .LandingPageV4_newsletterTitle__OMI9U {
    font-size: 26px;
  }

  .LandingPageV4_newsletterForm__SlMqm {
    flex-direction: row;
  }

  .LandingPageV4_newsletterBtn__kYFon {
    width: auto;
  }

  .LandingPageV4_footer__\\+l-US {
    padding-top: 24px;
  }

  .LandingPageV4_footerGrid__QMMCm {
    gap: 18px 20px;
    margin-bottom: 14px;
  }
}

@media (max-width: 480px) {
  .LandingPageV4_sectionEyebrow__PSy7g {
    margin-bottom: 7px;
    font-size: 10px;
  }

  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding-right: 12px;
    padding-left: 12px;
  }

  .LandingPageV4_logo__OsjVE {
    width: 102px;
  }

  .LandingPageV4_signInBtn__IPzgy {
    min-width: 40px;
    padding: 0 9px;
  }

  .LandingPageV4_signUpBtn__VZWBW {
    padding: 0 11px;
  }

  .LandingPageV4_trustBarGrid__S56x- {
    gap: 14px 8px;
  }

  .LandingPageV4_trustBarCard__C43QQ {
    padding: 17px 14px;
  }

  .LandingPageV4_trustItem__NkSuB {
    gap: 7px;
  }

  .LandingPageV4_trustIcon__-ANnJ {
    width: 35px;
    height: 35px;
  }

  .LandingPageV4_trustText__jxtdf {
    font-size: 16px;
  }

  .LandingPageV4_trustSubtext__TKs1m {
    font-size: 9.5px;
    letter-spacing: 0.035em;
  }

  .LandingPageV4_categoryStrip__Ud\\+Yg {
    padding-top: 44px;
    padding-bottom: 40px;
  }

  .LandingPageV4_categoryScrollWrapper__O5aqT {
    margin-right: -20px;
  }

  .LandingPageV4_categoryPill__bHh52 {
    width: clamp(120px, 38vw, 136px);
  }

  .LandingPageV4_howCard__swxRV {
    padding: 18px;
  }

  .LandingPageV4_howCardTitle__r94bk {
    font-size: 19px;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 330px;
  }

  .LandingPageV4_orderCardContentOverlay__sJmUk {
    padding: 19px;
  }

  .LandingPageV4_orderCardMode__O\\+AyS {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 9px;
  }

  .LandingPageV4_orderCardBadge__ONFKd {
    font-size: 9px;
  }

  .LandingPageV4_orderCardTitle__9Wrq3 {
    font-size: 28px;
  }

  .LandingPageV4_orderCardText__3Kb9a {
    font-size: 14px;
    line-height: 1.5;
  }

  .LandingPageV4_orderCardBtnPrimary__W22cs,
  .LandingPageV4_orderCardBtnOutline__HB1Yo {
    min-height: 48px;
    padding-right: 17px;
    padding-left: 17px;
    font-size: 13px;
  }

  .LandingPageV4_partnerCard__arAP1 {
    padding: 26px 19px 22px;
    gap: 21px;
    border-radius: 24px;
  }

  .LandingPageV4_partnerEyebrow__RY\\+c3 {
    font-size: 9px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(32px, 9.5vw, 39px);
    line-height: 1.02;
  }

  .LandingPageV4_partnerDescription__TKVul {
    font-size: 14px;
    line-height: 1.55;
  }

  .LandingPageV4_partnerFeatureList__s-SXi {
    display: flex;
    gap: 6px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi li {
    width: fit-content;
    min-height: 32px;
    padding: 6px 8px;
    font-size: 10.5px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: 100%;
    padding: 0;
  }

  .LandingPageV4_newsletter__DV3bX {
    padding: 26px 0;
  }

  .LandingPageV4_newsletterCard__bdoK- {
    padding: 23px 20px;
    gap: 19px;
  }

  .LandingPageV4_newsletterIcon__W7t8k {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
  }

  .LandingPageV4_newsletterTitle__OMI9U {
    font-size: 23px;
  }

  .LandingPageV4_newsletterSubtitle__-kL1i {
    font-size: 13px;
  }

  .LandingPageV4_newsletterForm__SlMqm {
    width: 100%;
    flex-direction: column;
    gap: 7px;
  }

  .LandingPageV4_newsletterInput__FNmSs {
    width: 100%;
    min-height: 50px;
    padding-right: 11px;
    padding-left: 40px;
    font-size: 13px;
  }

  .LandingPageV4_newsletterInputIcon__DxKI9 {
    top: 25px;
    left: 13px;
  }

  .LandingPageV4_newsletterBtn__kYFon {
    width: 100%;
    min-height: 50px;
    padding-right: 16px;
    padding-left: 16px;
    font-size: 13px;
  }

  .LandingPageV4_newsletterTerms__wLreU {
    max-width: 100%;
    font-size: 10px;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .LandingPageV4_footerGrid__QMMCm {
    gap: 14px 18px;
  }

  .LandingPageV4_footerBrand__ol-2d {
    gap: 8px;
  }

  .LandingPageV4_footerBrandDescription__kq\\+iG {
    font-size: 13px;
  }

  .LandingPageV4_footerColumn__cTUqZ h4 {
    margin-bottom: 5px;
  }

  .LandingPageV4_footerColumn__cTUqZ a {
    min-height: 38px;
  }

  .LandingPageV4_footerContactLink__is6TE {
    min-height: 42px;
  }

  .LandingPageV4_footerBottom__L6WSo {
    padding-top: 12px;
    padding-bottom: 14px;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .LandingPageV4_partnerDescription__TKVul {
    max-width: 450px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi {
    max-width: 470px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: min(100%, 520px);
  }
}

@media (min-width: 640px) and (max-width: 768px) {
  .LandingPageV4_partnerCard__arAP1 {
    min-height: 0;
    padding: 34px;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    align-items: center;
    gap: 26px;
  }

  .LandingPageV4_partnerCardContent__PJG6c {
    max-width: 620px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(36px, 5.8vw, 44px);
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: min(100%, 620px);
    margin: 0 auto;
  }
}

@media (min-width: 720px) and (max-width: 959px) {
  .LandingPageV4_partnerCard__arAP1 {
    min-height: 0;
    padding: 38px 38px 34px;
    grid-template-columns: minmax(0, 1fr);
    gap: 28px;
    background:
      radial-gradient(circle at 70% 64%, rgba(13, 111, 255, 0.17), transparent 32%),
      radial-gradient(circle at 10% 25%, rgba(76, 108, 255, 0.21), transparent 36%),
      linear-gradient(180deg, #103e79 0%, #082b59 42%, #010813 61%, #000000 76%);
  }

  .LandingPageV4_partnerCardContent__PJG6c {
    max-width: 700px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    max-width: 680px;
    font-size: clamp(40px, 5.6vw, 50px);
  }

  .LandingPageV4_partnerDescription__TKVul {
    max-width: 620px;
    font-size: 15px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi {
    gap: 8px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi li {
    min-height: 36px;
    padding: 7px 10px;
    font-size: 11px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: min(100%, 720px);
    margin: 0 auto;
    padding: 0;
    justify-self: center;
  }

  .LandingPageV4_partnerExperience__t4iqF::before {
    top: 9%;
    right: -3%;
    bottom: 9%;
    left: 5%;
    display: block;
  }

}

@media (min-width: 720px) and (max-width: 992px) {
  .LandingPageV4_howGrid__QU9Qg {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .LandingPageV4_howCard__swxRV {
    min-height: 250px;
    padding: 18px;
  }

  .LandingPageV4_orderOptionsGrid__gtton {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 380px;
  }
}

@media (max-width: 359px) {
  .LandingPageV4_header__7wrpI .LandingPageV4_innerWrapper__jP322 {
    padding-right: 8px;
    padding-left: 8px;
  }

  .LandingPageV4_logo__OsjVE {
    width: 86px;
  }

  .LandingPageV4_signInBtn__IPzgy {
    padding-right: 7px;
    padding-left: 7px;
    font-size: 11px;
  }

  .LandingPageV4_signUpBtn__VZWBW {
    padding-right: 9px;
    padding-left: 9px;
    font-size: 11px;
  }

  .LandingPageV4_trustBar__oHfgX {
    padding-right: 11px;
    padding-left: 11px;
  }

  .LandingPageV4_trustBarCard__C43QQ {
    padding-right: 11px;
    padding-left: 11px;
  }

  .LandingPageV4_trustIcon__-ANnJ {
    width: 32px;
    height: 32px;
  }

  .LandingPageV4_trustText__jxtdf {
    font-size: 15px;
  }

  .LandingPageV4_trustSubtext__TKs1m {
    font-size: 8.8px;
  }

  .LandingPageV4_categoryScrollWrapper__O5aqT {
    margin-right: -14px;
  }

  .LandingPageV4_categoryPills__kiyYa {
    padding-right: 14px;
  }

  .LandingPageV4_categoryPill__bHh52 {
    width: 121px;
  }

  .LandingPageV4_orderCard__cl6WT {
    height: 334px;
  }

  .LandingPageV4_orderCardMode__O\\+AyS {
    max-width: 135px;
    white-space: normal;
  }

  .LandingPageV4_newsletterForm__SlMqm {
    flex-direction: column;
  }

  .LandingPageV4_newsletterInputIcon__DxKI9 {
    top: 25px;
  }

  .LandingPageV4_newsletterBtn__kYFon {
    width: 100%;
  }

  .LandingPageV4_footerGrid__QMMCm {
    column-gap: 14px;
  }
}

/* ===== Connected retail showcase ===== */
.LandingPageV4_partnerSection__dGi7F {
  position: relative;
  padding: clamp(42px, 4.8vw, 62px) 0;
  overflow: hidden;
  scroll-margin-top: 72px;
  background:
    radial-gradient(circle at 8% 8%, rgba(15, 106, 255, 0.1), transparent 28%),
    radial-gradient(circle at 92% 90%, rgba(96, 74, 255, 0.07), transparent 25%),
    linear-gradient(180deg, #f7faff 0%, #f1f6fc 100%);
  isolation: isolate;
}

.LandingPageV4_partnerSection__dGi7F::before {
  content: none;
}

.LandingPageV4_partnerSection__dGi7F::after {
  content: none;
}

.LandingPageV4_partnerSection__dGi7F .LandingPageV4_innerWrapper__jP322 {
  position: relative;
  z-index: 1;
  max-width: 1600px;
}

.LandingPageV4_partnerCard__arAP1 {
  position: relative;
  min-height: 548px;
  padding: 42px 40px 40px 50px;
  display: grid;
  grid-template-columns: minmax(360px, 0.82fr) minmax(0, 1.18fr);
  align-items: center;
  gap: clamp(25px, 3vw, 48px);
  overflow: hidden;
  isolation: isolate;
  border: 1px solid rgba(130, 187, 255, 0.24);
  border-radius: 36px;
  background:
    radial-gradient(circle at 79% 44%, rgba(29, 120, 255, 0.2), transparent 32%),
    radial-gradient(circle at 5% 112%, rgba(67, 101, 255, 0.3), transparent 42%),
    linear-gradient(116deg, #154984 0%, #0b3364 37%, #061a36 52%, #01050d 100%);
  box-shadow:
    0 28px 70px rgba(5, 34, 76, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
  text-align: left;
}

.LandingPageV4_partnerCard__arAP1::before {
  position: absolute;
  z-index: 0;
  inset: 0;
  background:
    linear-gradient(rgba(133, 189, 255, 0.048) 1px, transparent 1px),
    linear-gradient(90deg, rgba(133, 189, 255, 0.048) 1px, transparent 1px);
  background-size: 48px 48px;
  content: '';
  opacity: 0.72;
  pointer-events: none;
  mask-image: linear-gradient(90deg, transparent 30%, #000 74%);
}

.LandingPageV4_partnerCard__arAP1::after {
  position: absolute;
  z-index: 0;
  width: 430px;
  height: 430px;
  right: -190px;
  bottom: -265px;
  border-radius: 50%;
  background: rgba(28, 111, 255, 0.14);
  box-shadow: 0 0 110px rgba(39, 118, 255, 0.26);
  content: '';
  pointer-events: none;
}

.LandingPageV4_partnerCardContent__PJG6c {
  position: relative;
  z-index: 3;
  min-width: 0;
  align-self: center;
}

.LandingPageV4_partnerEyebrow__RY\\+c3 {
  width: fit-content;
  margin: 0 0 13px;
  padding: 7px 13px;
  border: 1px solid rgba(144, 198, 255, 0.3);
  border-radius: 999px;
  background: rgba(20, 106, 227, 0.2);
  color: #edf7ff;
  font-size: 10px;
  font-weight: 820;
  letter-spacing: 0.1em;
  line-height: 17px;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
}

.LandingPageV4_partnerTitle__lXaxl {
  max-width: 560px;
  margin: 0 0 15px;
  color: #ffffff;
  font-size: clamp(38px, 3.45vw, 49px);
  letter-spacing: -0.052em;
  line-height: 1.015;
  text-wrap: balance;
}

.LandingPageV4_partnerDescription__TKVul {
  max-width: 500px;
  margin: 0 0 20px;
  padding: 0;
  color: #c9ddf7;
  font-size: 15.5px;
  font-weight: 540;
  line-height: 1.62;
}

.LandingPageV4_partnerFeatureList__s-SXi {
  margin: 0 0 24px;
  padding: 0;
  display: flex;
  flex-flow: row wrap;
  gap: 10px 17px;
  list-style: none;
}

.LandingPageV4_partnerFeatureList__s-SXi li {
  width: auto;
  min-height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  color: #f5f9ff;
  font-size: 11.5px;
  font-weight: 720;
  white-space: nowrap;
}

.LandingPageV4_partnerFeatureList__s-SXi svg {
  flex: 0 0 auto;
  color: #79b8ff;
}

.LandingPageV4_partnerGlassBtn__n1\\+62 {
  min-height: 50px;
  padding: 0 21px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 1px solid #ffffff;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 13px 29px rgba(0, 0, 0, 0.18);
  color: #0758dd;
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  transition:
    background 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.LandingPageV4_partnerGlassBtn__n1\\+62:hover {
  background: #eef6ff;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.24);
  transform: translateY(-2px);
}

.LandingPageV4_partnerGlassBtn__n1\\+62:focus-visible {
  outline: 3px solid rgba(255, 255, 255, 0.72);
  outline-offset: 4px;
}

.LandingPageV4_partnerExperience__t4iqF {
  position: relative;
  z-index: 2;
  width: min(100%, 760px);
  min-width: 0;
  min-height: 470px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-self: end;
  isolation: isolate;
}

.LandingPageV4_partnerExperience__t4iqF::before {
  content: none;
}

.LandingPageV4_partnerPlatformHalo__cL2Uj {
  position: absolute;
  z-index: -1;
  inset: 3% -11% 5% -2%;
  border-radius: 50%;
  background:
    radial-gradient(circle at 51% 48%, rgba(20, 119, 255, 0.25), transparent 54%),
    radial-gradient(circle at 72% 72%, rgba(110, 77, 255, 0.2), transparent 43%);
  filter: blur(42px);
  opacity: 0.9;
  pointer-events: none;
}

.LandingPageV4_partnerPlatformKicker__UeP-u {
  margin: 0 0 4px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d9eaff;
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.105em;
  line-height: 18px;
  text-transform: uppercase;
}

.LandingPageV4_partnerPlatformPulse__\\+Hxd1 {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: #3c91ff;
  box-shadow:
    0 0 0 5px rgba(60, 145, 255, 0.12),
    0 0 18px rgba(60, 145, 255, 0.72);
  animation: LandingPageV4_partnerPulse__LqRUa 2.2s ease-in-out infinite;
}

.LandingPageV4_partnerPlatformKickerLabel__C-6hJ {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Animated isometric platform deck (see Components/IsometricShowcase). */
.LandingPageV4_partnerShowcase__3L5nz {
  width: 100%;
  margin: 2px 0 6px;
}

/* Animated isometric platform deck (see Components/IsometricShowcase). */
.LandingPageV4_partnerShowcase__3L5nz {
  width: 100%;
  margin: 2px 0 6px;
}

.LandingPageV4_partnerViewTimeline__etnfH {
  margin: 4px 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(16px, 2.5vw, 30px);
  list-style: none;
}

.LandingPageV4_partnerViewTimelineItem__xOI7p {
  min-width: 0;
  min-height: 52px;
  padding: 8px 7px 3px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  color: #d9eaff;
  text-align: left;
}

.LandingPageV4_partnerViewTimelineIcon__dYCmU {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(134, 192, 255, 0.24);
  border-radius: 10px;
  background: linear-gradient(
    145deg,
    rgba(18, 120, 255, 0.34),
    rgba(75, 67, 238, 0.25)
  );
  color: #dcecff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.LandingPageV4_partnerViewTimelineCopy__mAx4F {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.LandingPageV4_partnerViewTimelineCopy__mAx4F strong,
.LandingPageV4_partnerViewTimelineCopy__mAx4F small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.LandingPageV4_partnerViewTimelineCopy__mAx4F strong {
  color: inherit;
  font-size: 10.5px;
  font-weight: 790;
}

.LandingPageV4_partnerViewLabelCompact__1tonz {
  display: none;
}

.LandingPageV4_partnerViewTimelineCopy__mAx4F small {
  color: #87a5c8;
  font-size: 8.8px;
  font-weight: 620;
}

@keyframes LandingPageV4_partnerPulse__LqRUa {
  50% {
    opacity: 0.6;
    transform: scale(0.88);
  }
}

@media (max-width: 1120px) {
  .LandingPageV4_partnerCard__arAP1 {
    padding-right: 30px;
    padding-left: 40px;
    grid-template-columns: minmax(330px, 0.78fr) minmax(0, 1.22fr);
    gap: 25px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(36px, 4vw, 45px);
  }

}

@media (max-width: 959px) {
  .LandingPageV4_partnerCard__arAP1 {
    min-height: 0;
    padding: 39px 38px 31px;
    grid-template-columns: minmax(0, 1fr);
    gap: 25px;
    background:
      radial-gradient(circle at 69% 66%, rgba(18, 111, 255, 0.18), transparent 33%),
      radial-gradient(circle at 8% 20%, rgba(75, 108, 255, 0.2), transparent 36%),
      linear-gradient(180deg, #12457f 0%, #0a3060 42%, #04142b 59%, #01050d 100%);
  }

  .LandingPageV4_partnerCardContent__PJG6c {
    max-width: 720px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    max-width: 690px;
  }

  .LandingPageV4_partnerDescription__TKVul {
    max-width: 640px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: min(100%, 760px);
    min-height: 0;
    margin: 0 auto;
    justify-self: center;
  }

}

@media (max-width: 768px) {
  .LandingPageV4_partnerSection__dGi7F {
    padding: 40px 0;
  }

  .LandingPageV4_partnerCard__arAP1 {
    padding: 32px 28px 25px;
    gap: 22px;
    border-radius: 28px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: clamp(35px, 7.2vw, 45px);
  }


}

@media (max-width: 480px) {
  .LandingPageV4_partnerSection__dGi7F {
    padding: 34px 0;
  }

  .LandingPageV4_partnerCard__arAP1 {
    padding: 25px 19px 20px;
    gap: 18px;
    border-radius: 24px;
  }

  .LandingPageV4_partnerEyebrow__RY\\+c3 {
    margin-bottom: 10px;
    padding: 6px 10px;
    font-size: 8.8px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    margin-bottom: 13px;
    font-size: clamp(31px, 9.2vw, 37px);
    line-height: 1.02;
  }

  .LandingPageV4_partnerDescription__TKVul {
    margin-bottom: 17px;
    font-size: 13.7px;
    line-height: 1.55;
  }

  .LandingPageV4_partnerFeatureList__s-SXi {
    margin-bottom: 20px;
    gap: 8px 13px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi li {
    min-height: 24px;
    gap: 5px;
    font-size: 10.2px;
  }

  .LandingPageV4_partnerFeatureList__s-SXi svg {
    width: 15px;
    height: 15px;
  }

  .LandingPageV4_partnerGlassBtn__n1\\+62 {
    width: 100%;
    min-height: 48px;
    justify-content: center;
    padding-right: 15px;
    padding-left: 15px;
    font-size: 12.5px;
  }

  .LandingPageV4_partnerExperience__t4iqF {
    width: 100%;
  }

  .LandingPageV4_partnerPlatformHalo__cL2Uj {
    inset: 5% -8% 9%;
    display: block;
    filter: blur(29px);
    opacity: 0.64;
  }

  .LandingPageV4_partnerPlatformKicker__UeP-u {
    margin-bottom: 0;
    padding: 0 2px;
    font-size: 8px;
  }




  .LandingPageV4_partnerViewTimeline__etnfH {
    margin-top: 1px;
    gap: 10px;
  }

  .LandingPageV4_partnerViewTimelineItem__xOI7p {
    min-height: 50px;
    padding: 10px 2px 3px;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 7px;
  }

  .LandingPageV4_partnerViewTimelineIcon__dYCmU {
    width: 28px;
    height: 28px;
    border-radius: 9px;
  }

  .LandingPageV4_partnerViewTimelineCopy__mAx4F strong {
    font-size: 9.2px;
  }

  .LandingPageV4_partnerViewLabelFull__wSsKF {
    display: none;
  }

  .LandingPageV4_partnerViewLabelCompact__1tonz {
    display: inline;
  }

  .LandingPageV4_partnerViewTimelineCopy__mAx4F small {
    display: none;
  }
}

@media (max-width: 359px) {
  .LandingPageV4_partnerCard__arAP1 {
    padding-right: 15px;
    padding-left: 15px;
  }

  .LandingPageV4_partnerTitle__lXaxl {
    font-size: 29px;
  }


  .LandingPageV4_partnerViewTimelineIcon__dYCmU {
    width: 27px;
    height: 27px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .LandingPageV4_partnerGlassBtn__n1\\+62 {
    transition: none;
  }

  .LandingPageV4_partnerPlatformPulse__\\+Hxd1 {
    animation: none;
  }



}
`, "",{"version":3,"sources":["webpack://./src/Components/LandingPage/LandingPageV4.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sDAAsD;EACtD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kDAAkD;EAClD;;kEAEgE;EAChE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB;;;wBAGsB;AACxB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;EACrD,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6CAA6C;EAC7C;;;wBAGsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,2DAA2D;AAC7D;;AAEA;EACE,QAAQ;EACR,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB;;cAEY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+DAA+D;EAC/D,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;AACT;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,2BAA2B;EAC3B,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C;;;wCAGsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,oBAAoB;EACpB,6DAA6D;EAC7D,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;kEAEgE;EAChE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR;;2EAEyE;EACzE,0BAA0B;EAE1B,4EAA4E;EAC5E,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mGAAmG;EACnG,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2DAA2D;EAC3D,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;;;;;;;;;;;;EAYE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;IAChD,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,gDAAgD;IAChD,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB;;;yBAGuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C;;6BAE2B;EAC3B;;qCAEmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB;;QAEM;AACR;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;QAEM;EACN;;oCAEkC;EAClC;;;wBAGsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB;;oCAEkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,cAAc;EACd;;wBAEsB;AACxB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yDAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB;;;WAGS;EACT,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;EAC/C,gBAAgB;EAChB;;;wBAGsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;EACrD,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB;;;WAGS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8DAA8D;EAC9D,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;mEAEiE;AACnE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB;;;wBAGsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB;;;qDAGmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB;;;;;;;;;;KAUG;EACH;;2CAEyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR;;;;iFAI+E;EAC/E,iDAAiD;EAEjD,gEAAgE;EAChE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,mDAAmD;EACnD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;EACV,UAAU;EACV,QAAQ;EACR,0CAA0C;EAC1C,mBAAmB;EACnB;;;;GAIC;EACD,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB;;6CAE2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qDAAqD;EACrD,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,iEAAiE;EACnE;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT;;;;;;;;;;OAUG;IACH,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,OAAO;IACP,UAAU;IACV,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,qCAAqC;IACrC,SAAS;IACT;;;gFAG4E;EAC9E;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,OAAO;IACP,UAAU;IACV,UAAU;IACV,QAAQ;IACR,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB;;;qDAGmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB;;;+EAG6E;EAC7E;;2CAEyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR;;2EAEyE;EACzE,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,oBAAoB;EAEpB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,8CAA8C;EAC9C,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB;;;wBAGsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB;;gFAE8E;EAC9E,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB;;qCAEmC;EACnC,sEAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB;;;;GAIC;EACD,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,8DAA8D;IAC9D,SAAS;EACX;;EAEA;IACE,iCAAiC;EACnC;;AAEF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,qCAAqC;IACrC,SAAS;IACT;;;iFAG6E;EAC/E;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,oBAAoB;EACtB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;;AAGF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;;;;EAKA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;IAC1C,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;;;AAIF","sourcesContent":["@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Main page wrapper */\n.pageWrapper {\n  background: #f8f9ff;\n  min-height: 100vh;\n  font-family: 'Manrope', 'Inter', system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Hero + TrustBar: fill first viewport below header so stats row stays visible */\n.heroViewport {\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 72px);\n  min-height: calc(100dvh - 72px);\n}\n\n.heroViewport .trustBar {\n  flex-shrink: 0;\n}\n\n.innerWrapper {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 32px;\n}\n\n/* ===== Header ===== */\n.header {\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  border-bottom: 1px solid rgba(130, 166, 207, 0.22);\n  background:\n    radial-gradient(circle at 82% -80%, rgba(10, 100, 249, 0.32), transparent 34%),\n    linear-gradient(118deg, #071c38 0%, #091e3a 54%, #0c315c 100%);\n  box-shadow: 0 8px 24px rgba(4, 20, 42, 0.18);\n}\n\n.header .innerWrapper {\n  width: 100%;\n  max-width: 1600px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.logo {\n  width: 148px;\n  max-width: 100%;\n  height: auto;\n  cursor: pointer;\n  filter: brightness(0) invert(1);\n}\n\n.logoButton {\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0;\n  display: inline-grid;\n  place-items: center;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0);\n  cursor: pointer;\n  transition:\n    border-color 160ms ease,\n    background 160ms ease;\n}\n\n.logoButton:hover {\n  border-color: rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.headerButtons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.signInBtn {\n  min-height: 44px;\n  padding: 0 18px;\n  font-size: 14px;\n  font-weight: 750;\n  color: #f7faff;\n  background: rgba(255, 255, 255, 0.065);\n  border: 1px solid rgba(151, 183, 221, 0.28);\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition:\n    border-color 160ms ease,\n    background 160ms ease,\n    transform 160ms ease;\n}\n\n.signInBtn:hover {\n  color: #ffffff;\n  border-color: rgba(117, 173, 255, 0.68);\n  background: rgba(10, 100, 249, 0.18);\n  transform: translateY(-1px);\n}\n\n.signUpBtn {\n  min-height: 44px;\n  padding: 0 20px;\n  font-size: 14px;\n  font-weight: 800;\n  color: white;\n  background: linear-gradient(145deg, #1a78ff, #0755d8);\n  border: 1px solid rgba(126, 181, 255, 0.38);\n  border-radius: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 8px 18px rgba(0, 76, 190, 0.32);\n  transition:\n    background 160ms ease,\n    box-shadow 160ms ease,\n    transform 160ms ease;\n}\n\n.signUpBtn:hover {\n  background: linear-gradient(145deg, #2b84ff, #0960ef);\n  box-shadow: 0 10px 24px rgba(0, 88, 218, 0.42);\n  transform: translateY(-1px);\n}\n\n/* Profile menu styles */\n.profileMenuWrapper {\n  position: relative;\n}\n\n.profileBtn {\n  height: 44px;\n  width: 44px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.09);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(151, 183, 221, 0.28);\n  cursor: pointer;\n  transition:\n    border-color 160ms ease,\n    background 160ms ease;\n}\n\n.profileBtn:hover {\n  border-color: rgba(117, 173, 255, 0.68);\n  background: rgba(10, 100, 249, 0.2);\n}\n\n.iconSm {\n  width: 20px;\n  height: 20px;\n}\n\n.profileMenu {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin-top: 12px;\n  width: 288px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n  z-index: 50;\n  overflow: hidden;\n}\n\n.profileHeader {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.profileName {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n}\n\n.profileEmail {\n  font-size: 14px;\n  color: #6b7280;\n  word-break: break-all;\n  margin: 2px 0 0 0;\n}\n\n.menuList {\n  list-style: none;\n  padding: 4px 0;\n  margin: 0;\n}\n\n.menuItemBtn {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 16px;\n  text-align: left;\n  color: #1f2937;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.menuItemBtn:hover {\n  background: #f9fafb;\n}\n\n.menuDivider {\n  border-top: 1px solid #f3f4f6;\n}\n\n.logoutBtn {\n  width: 100%;\n  min-height: 44px;\n  padding: 12px 16px;\n  text-align: left;\n  color: #111827;\n  background: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.logoutBtn:hover {\n  background: #f9fafb;\n}\n\n/* ===== Trust Signals / Stats Bar ===== */\n.trustBar {\n  position: relative;\n  z-index: 10;\n  margin-top: -56px;\n  padding: 0 32px;\n  margin-bottom: 16px;\n}\n\n.trustBarCard {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 82, 255, 0.06);\n  padding: 32px 40px;\n  max-width: 1280px;\n  margin: 0 auto;\n}\n\n.trustBarGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n}\n\n.trustItem {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 0 16px;\n  border-right: 1px solid #e2e8f0;\n}\n\n.trustItem:last-child {\n  border-right: none;\n}\n\n.trustIcon {\n  width: 48px;\n  height: 48px;\n  background: #eff6ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0052ff;\n  flex-shrink: 0;\n}\n\n.trustTextWrap {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n\n.trustText {\n  font-size: 24px;\n  font-weight: 900;\n  color: #0b1c30;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.trustSubtext {\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n/* ===== Category Strip ===== */\n.categoryStrip {\n  padding: 64px 0;\n  background: #f8f9ff;\n}\n\n.categoryHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 32px;\n  gap: 24px;\n}\n\n.categoryHeaderText {\n  flex: 1;\n}\n\n.categoryTitle {\n  font-size: 30px;\n  font-weight: 800;\n  color: #0b1c30;\n  letter-spacing: -0.02em;\n  margin-bottom: 8px;\n}\n\n.categoryDescription {\n  font-size: 16px;\n  color: #64748b;\n  max-width: 480px;\n  line-height: 1.5;\n}\n\n.categoryNavButtons {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.categoryArrow {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: transparent;\n  border: 1.5px solid rgba(195, 197, 217, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #434656;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.categoryArrow:hover:not(:disabled) {\n  background: white;\n  border-color: #0052ff;\n  color: #0052ff;\n}\n\n.categoryArrowDisabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.categoryScrollWrapper {\n  position: relative;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.categoryFadeLeft,\n.categoryFadeRight {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 60px;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.categoryFadeLeft {\n  left: 0;\n  background: linear-gradient(to right, #f8f9ff, transparent);\n}\n\n.categoryFadeRight {\n  right: 0;\n  background: linear-gradient(to left, #f8f9ff, transparent);\n}\n\n.categoryPills {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  gap: 16px;\n  overflow-x: auto;\n  flex-wrap: nowrap;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding: 8px 4px;\n  scroll-snap-type: x mandatory;\n}\n\n.categoryPills::-webkit-scrollbar {\n  display: none;\n}\n\n.categoryPill {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 24px;\n  background: white;\n  border: none;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0b1c30;\n  cursor: pointer;\n  flex-shrink: 0;\n  width: 160px;\n  min-height: 140px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  transition: all 0.25s;\n  scroll-snap-align: start;\n  text-align: center;\n  font-family: inherit;\n  appearance: none;\n}\n\n.categoryPill:disabled {\n  cursor: wait;\n}\n\n.categoryIconContainer {\n  width: 80px;\n  height: 80px;\n  background: #e5eeff;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n  color: #0b1c30;\n  font-size: 36px;\n}\n\n.categoryPill:hover {\n  box-shadow: 0 8px 24px rgba(0, 82, 255, 0.1);\n}\n\n.categoryPill:hover .categoryIconContainer {\n  background: #0052ff;\n  color: white;\n}\n\n/* ===== Content Sections (kept for backward compat) ===== */\n.contentSection {\n  background: white;\n  padding: 80px 0;\n  display: flex;\n  align-items: center;\n  gap: 64px;\n}\n\n.contentSectionReverse {\n  flex-direction: row-reverse;\n  background: #f9fafb;\n}\n\n.contentText {\n  flex: 1;\n}\n\n.contentTitle {\n  font-size: 36px;\n  font-weight: 700;\n  color: #0b1c30;\n  margin-bottom: 20px;\n  line-height: 1.15;\n}\n\n.contentDescription {\n  font-size: 18px;\n  color: #475569;\n  line-height: 1.65;\n  margin-bottom: 28px;\n}\n\n.contentImage {\n  flex: 1;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.ctaBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  margin-top: 4px;\n  background: transparent;\n  color: #0052ff;\n  border: 1.5px solid #0052ff;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition:\n    background 0.2s,\n    color 0.2s;\n}\n\n.ctaBtn:hover {\n  background: #0052ff;\n  color: white;\n}\n\n/* ===== Order Options / Services ===== */\n.orderOptions {\n  background: #eff4ff;\n  padding: 80px 0;\n}\n\n.orderOptionsHeader {\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.sectionTitle {\n  font-size: 36px;\n  font-weight: 700;\n  color: #0b1c30;\n  margin-bottom: 12px;\n}\n\n.sectionSubtitle {\n  font-size: 18px;\n  color: #475569;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n\n.orderOptionsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.orderCard {\n  position: relative;\n  height: 550px;\n  border-radius: 24px;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-end;\n  box-shadow: 0 16px 48px rgba(0, 82, 255, 0.08);\n}\n\n.orderCard:hover .orderCardImageFull {\n  transform: scale(1.05);\n}\n\n.orderCardImageFull {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 1000ms ease;\n}\n\n.orderCardOverlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.85),\n    rgba(0, 0, 0, 0.35) 50%,\n    transparent\n  );\n  z-index: 1;\n}\n\n.orderCardContentOverlay {\n  position: relative;\n  z-index: 2;\n  padding: 48px;\n  width: 100%;\n}\n\n.orderCardBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #0052ff;\n  color: white;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 16px;\n  box-shadow: 0 4px 16px rgba(0, 82, 255, 0.4);\n}\n\n.orderCardTitle {\n  font-size: 36px;\n  font-weight: 800;\n  color: white;\n  letter-spacing: -0.03em;\n  margin-bottom: 12px;\n}\n\n.orderCardText {\n  font-size: 18px;\n  color: #e2e8f0;\n  margin-bottom: 0;\n  /* padding so gap to CTA doesn’t collapse with button margins */\n  padding-bottom: 24px;\n  line-height: 1.6;\n  max-width: 400px;\n}\n\n.orderCardBtnPrimary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  color: #0b1c30;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 28px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Manrope', sans-serif;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.orderCardBtnPrimary:hover {\n  background: #f1f5f9;\n}\n\n.orderCardBtnOutline {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n  color: #0b1c30;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 28px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Manrope', sans-serif;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.orderCardBtnOutline:hover {\n  background: #f1f5f9;\n}\n\n/* ===== Partner Section ===== */\n.partnerSection {\n  padding: 80px 0;\n  background: #f8f9ff;\n}\n\n.partnerCard {\n  background: #003ec7;\n  border-radius: 32px;\n  padding: 80px;\n  display: flex;\n  align-items: center;\n  gap: 64px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(0, 62, 199, 0.2);\n}\n\n.partnerCardContent {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n}\n\n.partnerTitle {\n  font-size: clamp(32px, 4vw, 56px);\n  font-weight: 900;\n  color: white;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n  margin-bottom: 24px;\n}\n\n.partnerDescription {\n  font-size: 18px;\n  color: rgba(191, 219, 254, 0.9);\n  line-height: 1.65;\n  margin-bottom: 0;\n  padding-bottom: 24px;\n  max-width: 480px;\n}\n\n.partnerGlassBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  color: white;\n  border-radius: 12px;\n  padding: 18px 32px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-decoration: none;\n}\n\n.partnerGlassBtn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.phoneMockup {\n  width: 310px;\n  height: 630px;\n  background: #020617;\n  border-radius: 48px;\n  overflow: hidden;\n  padding: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.1),\n    0 0 0 4px #0f172a,\n    0 20px 50px -10px rgba(0, 0, 0, 0.5);\n  transform: rotate(3deg);\n}\n\n.phoneScreen {\n  width: 100%;\n  height: 100%;\n  background: #020617;\n  border-radius: 40px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.3);\n}\n\n.phoneScreenContent {\n  position: absolute;\n  inset: 0;\n  padding: 24px;\n  padding-top: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Merchant Dashboard Header */\n.phoneMerchantHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.phoneMerchantLabel {\n  font-size: 10px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-bottom: 2px;\n}\n\n.phoneMerchantTitle {\n  font-size: 18px;\n  font-weight: 800;\n  color: white;\n}\n\n.phoneMerchantAvatar {\n  width: 40px;\n  height: 40px;\n  background: rgba(0, 82, 255, 0.2);\n  border-radius: 50%;\n  border: 1px solid rgba(0, 82, 255, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Metric Card */\n.phoneMetricCard {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.phoneMetricHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.phoneMetricLabel {\n  font-size: 10px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.phoneMetricBadge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #4ade80;\n  background: rgba(74, 222, 128, 0.1);\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n\n.phoneMetricValue {\n  font-size: 24px;\n  font-weight: 900;\n  color: white;\n}\n\n/* Sales Growth Chart Card */\n.phoneChartCard {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.phoneChartHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 16px;\n}\n\n.phoneChartValue {\n  font-size: 20px;\n  font-weight: 900;\n  color: white;\n  margin-top: 2px;\n}\n\n.phoneChartMiniBar {\n  display: flex;\n  gap: 3px;\n  height: 32px;\n  align-items: flex-end;\n}\n\n.phoneMiniBar1 {\n  width: 3px;\n  background: rgba(0, 82, 255, 0.2);\n  border-radius: 999px;\n}\n\n.phoneMiniBar2 {\n  width: 3px;\n  background: rgba(0, 82, 255, 0.4);\n  border-radius: 999px;\n}\n\n.phoneMiniBar3 {\n  width: 3px;\n  background: #0052ff;\n  border-radius: 999px;\n}\n\n.phoneLineChart {\n  height: 80px;\n  width: 100%;\n}\n\n/* Order Volume Bar Chart */\n.phoneBarChartCard {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.phoneBarChartBars {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  height: 96px;\n  gap: 6px;\n  padding: 0 4px;\n  margin-top: 12px;\n}\n\n.phoneBar {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px 2px 0 0;\n}\n\n.phoneBarActive {\n  background: #0052ff;\n}\n\n.phoneNotch {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 12px;\n}\n\n.phoneNotchLine {\n  width: 80px;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 999px;\n}\n\n/* ===== Newsletter Section ===== */\n.newsletter {\n  --newsletter-column-width: 480px;\n  padding: 42px 0 38px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  border-top: 1px solid #e1e9f3;\n  border-bottom: 1px solid #d9e5f2;\n  text-align: center;\n}\n\n.newsletterTitle {\n  font-size: clamp(28px, 2.5vw, 34px);\n  font-weight: 900;\n  color: #0b1c30;\n  letter-spacing: -0.02em;\n  margin-bottom: 8px;\n  line-height: 1.15;\n}\n\n.newsletterSubtitle {\n  font-size: 16px;\n  color: #64748b;\n  margin-bottom: 18px;\n  max-width: var(--newsletter-column-width);\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.5;\n}\n\n.newsletterSignup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.newsletterFormWrapper {\n  max-width: var(--newsletter-column-width);\n  width: 100%;\n  margin: 0 auto;\n}\n\n.newsletterForm {\n  display: flex;\n  gap: 12px;\n}\n\n.newsletterInput {\n  flex: 1;\n  min-width: 0;\n  min-height: 52px;\n  background: #f8f9ff !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px;\n  padding: 16px 20px;\n  color: #0b1c30 !important;\n  font-size: 16px;\n  font-family: 'Manrope', sans-serif;\n  outline: none;\n  transition: border-color 0.2s;\n  pointer-events: auto !important;\n  user-select: text !important;\n  -webkit-user-select: text !important;\n}\n\n.newsletterInput:focus {\n  border-color: #0052ff !important;\n}\n\n.newsletterBtn {\n  min-height: 52px;\n  background: linear-gradient(135deg, #003ec7 0%, #0052ff 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 28px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Manrope', sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: box-shadow 0.2s;\n  box-shadow: 0 2px 8px rgba(0, 82, 255, 0.15);\n}\n\n.newsletterBtn:hover {\n  box-shadow: 0 8px 24px rgba(0, 82, 255, 0.3);\n}\n\n.newsletterBtn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.newsletterTerms {\n  font-size: 13px;\n  color: #94a3b8;\n  margin-top: 12px;\n  margin-bottom: 0;\n  line-height: 1.45;\n}\n\n@media (min-width: 1025px) {\n  .newsletterTerms {\n    white-space: nowrap;\n    width: max-content;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.termsRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 16px;\n  font-size: 15px;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.hiddenCheckbox {\n  display: none;\n}\n\n.customCheckbox {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #4b5563;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.checkIcon {\n  color: #0052ff;\n  font-size: 12px;\n}\n\n.termsLabel {\n  font-size: 16px;\n  color: #9ca3af;\n  line-height: 1.4;\n}\n\n.termsLabel a {\n  color: #60a5fa;\n  text-decoration: none;\n}\n\n.termsLabel a:hover {\n  text-decoration: underline;\n}\n\n/* ===== Footer ===== */\n.footer {\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 84% -28%, rgba(10, 100, 249, 0.3), transparent 38%),\n    linear-gradient(135deg, #07192f 0%, #091e3a 52%, #0c294c 100%);\n  color: #ffffff;\n  padding: 30px 0 0;\n  border-top: 1px solid #173a63;\n}\n\n.footer::before {\n  position: absolute;\n  z-index: -1;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);\n  background-size: 44px 44px;\n  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 76%);\n  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 76%);\n  content: '';\n  pointer-events: none;\n}\n\n.footerNewsletter {\n  display: none;\n}\n\n.footerContent {\n  padding: 0;\n}\n\n.footerGrid {\n  display: grid;\n  grid-template-columns: minmax(220px, 1.65fr) repeat(3, minmax(112px, 0.75fr)) minmax(210px, 1.25fr);\n  gap: clamp(20px, 2.8vw, 42px);\n  margin-bottom: 20px;\n  align-items: start;\n}\n\n.footerHelpText {\n  font-size: 13px;\n  color: #a9bad0;\n  line-height: 1.5;\n  margin: 0 0 8px;\n}\n\n.footerContactLink {\n  display: inline-flex !important;\n  min-height: 40px;\n  align-items: center;\n  gap: 8px;\n}\n\n.footerContactLink .material-symbols-outlined {\n  color: #75adff;\n}\n\n.footerBrand {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footerBrand > a {\n  width: fit-content;\n  min-height: 44px;\n  display: inline-grid;\n  place-items: center;\n  border-radius: 12px;\n}\n\n.footerBrandDescription {\n  font-size: 14px;\n  color: #a9bad0;\n  line-height: 1.5;\n  max-width: 280px;\n  margin: 0;\n}\n\n.footerColumn h4 {\n  font-size: 11px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  color: #75adff;\n  text-transform: uppercase;\n  letter-spacing: 0.13em;\n  line-height: 16px;\n}\n\n.footerColumn ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footerColumn li {\n  margin: 0;\n}\n\n.footerColumn a {\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n  color: #bdcce0;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 18px;\n  transition: color 160ms ease;\n}\n\n.footerColumn a:hover {\n  color: #ffffff;\n}\n\n.footerLegalLink {\n  text-decoration: underline !important;\n  text-decoration-color: rgba(117, 173, 255, 0.45) !important;\n  text-underline-offset: 4px;\n}\n\n.footerBottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 58px;\n  padding: 10px 0;\n  border-top: 1px solid rgba(130, 166, 207, 0.22);\n}\n\n.footerLogo {\n  width: 132px;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  filter: brightness(0) invert(1);\n}\n\n.footerSocial {\n  display: flex;\n  gap: 12px;\n}\n\n.footerSocial a {\n  color: #dce9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid rgba(130, 166, 207, 0.28);\n  background: rgba(255, 255, 255, 0.065);\n  transition: all 0.2s;\n}\n\n.footerSocial a:hover {\n  color: white;\n  border-color: #4f91f7;\n  background: #0a64f9;\n}\n\n.footerCopyright {\n  font-size: 12px;\n  color: #8fa6c1;\n  font-weight: 500;\n  margin: 0;\n}\n\n.footerBadges {\n  display: flex;\n  gap: 18px;\n}\n\n.footerBadge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 900;\n  color: #9db1ca;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n/* Focus states for accessibility */\n.orderCardBtnPrimary:focus-visible,\n.orderCardBtnOutline:focus-visible,\n.partnerGlassBtn:focus-visible,\n.newsletterBtn:focus-visible,\n.categoryArrow:focus-visible,\n.categoryPill:focus-visible,\n.logoButton:focus-visible,\n.signInBtn:focus-visible,\n.signUpBtn:focus-visible,\n.profileBtn:focus-visible,\n.menuItemBtn:focus-visible,\n.logoutBtn:focus-visible {\n  outline: 2px solid #0052ff;\n  outline-offset: 2px;\n}\n\n.footerSocial a:focus-visible {\n  outline: 2px solid #0052ff;\n  outline-offset: 2px;\n}\n\n.footerBrand > a:focus-visible {\n  width: fit-content;\n  outline: 2px solid #0052ff;\n  outline-offset: 4px;\n}\n\n.header .logoButton:focus-visible,\n.header .signInBtn:focus-visible,\n.header .signUpBtn:focus-visible,\n.header .profileBtn:focus-visible {\n  outline-color: #8bb8ff;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 1200px) {\n  .header .innerWrapper {\n    padding: 0 24px;\n  }\n\n}\n\n@media (max-width: 992px) {\n  .orderOptionsGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .orderCard {\n    height: 450px;\n  }\n\n  .contentSection {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .contentSectionReverse {\n    flex-direction: column;\n  }\n\n  .footerGrid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px 32px;\n  }\n\n  .footerBrand {\n    grid-column: span 2;\n  }\n\n  .trustBarGrid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n\n  .trustItem {\n    justify-content: flex-start;\n    border-right: none;\n    padding: 0;\n  }\n\n  .categoryHeader {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .heroViewport {\n    min-height: calc(100vh - 60px);\n    min-height: calc(100dvh - 60px);\n  }\n\n  .innerWrapper {\n    padding: 0 20px;\n  }\n\n  .header {\n    height: 60px;\n  }\n\n  .header .innerWrapper {\n    padding: 0 16px;\n    gap: 12px;\n  }\n\n  .logo {\n    width: clamp(96px, 20vw, 116px);\n    height: auto;\n  }\n\n  .headerButtons {\n    gap: 7px;\n  }\n\n  .signInBtn {\n    min-height: 42px;\n    padding: 0 12px;\n    font-size: 13px;\n    gap: 6px;\n  }\n\n  .signUpBtn {\n    min-height: 42px;\n    padding: 0 14px;\n    font-size: 13px;\n  }\n\n  .profileBtn {\n    width: 42px;\n    height: 42px;\n  }\n\n  .profileMenu {\n    width: min(288px, calc(100vw - 24px));\n    max-height: calc(100dvh - 76px);\n    overflow-y: auto;\n  }\n\n  .trustBar {\n    margin-top: -40px;\n    padding: 0 16px;\n  }\n\n  .trustBarCard {\n    padding: 24px;\n  }\n\n  .trustText {\n    font-size: 20px;\n  }\n\n  .sectionTitle {\n    font-size: 28px;\n  }\n\n  .sectionSubtitle {\n    font-size: 15px;\n  }\n\n  .orderOptions {\n    padding: 56px 0;\n  }\n\n  .orderCard {\n    height: 380px;\n  }\n\n  .orderCardContentOverlay {\n    padding: 24px;\n  }\n\n  .orderCardTitle {\n    font-size: 28px;\n  }\n\n  .orderCardText {\n    font-size: 15px;\n    margin-bottom: 0;\n    padding-bottom: 16px;\n  }\n\n  .categoryStrip {\n    padding: 40px 0;\n  }\n\n  .categoryTitle {\n    font-size: 24px;\n  }\n\n  .categoryNavButtons {\n    display: none;\n  }\n\n  .categoryFadeLeft,\n  .categoryFadeRight {\n    display: none;\n  }\n\n  .categoryPill {\n    width: 130px;\n    padding: 16px;\n    min-height: 120px;\n  }\n\n  .categoryIconContainer {\n    width: 64px;\n    height: 64px;\n    font-size: 28px;\n  }\n\n  .newsletter {\n    padding: 34px 0 30px;\n  }\n\n  .newsletterTitle {\n    font-size: 27px;\n  }\n\n  .newsletterForm {\n    flex-direction: column;\n  }\n\n  .newsletterBtn {\n    width: 100%;\n  }\n\n  .newsletterSubtitle {\n    margin-bottom: 16px;\n  }\n\n  .footerGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 24px 20px;\n    margin-bottom: 18px;\n  }\n\n  .footerBrand {\n    grid-column: span 2;\n  }\n\n  .footerBottom {\n    flex-direction: column;\n    gap: 10px;\n    min-height: 0;\n    padding: 14px 0 16px;\n    text-align: center;\n  }\n\n  .footerBadges {\n    flex-flow: row wrap;\n    justify-content: center;\n    gap: 8px 14px;\n    align-items: center;\n  }\n\n  .footer {\n    padding: 28px 0 0;\n  }\n\n  .footerColumn a {\n    min-height: 40px;\n  }\n\n  .footerHelpText {\n    max-width: 420px;\n  }\n\n  .footerContactLink {\n    min-height: 44px;\n  }\n}\n\n@media (max-width: 480px) {\n  .categoryPills {\n    gap: 12px;\n  }\n\n  .categoryPill {\n    width: 116px;\n    min-height: 114px;\n    padding: 14px 10px;\n  }\n\n  .header .innerWrapper {\n    padding: 0 10px;\n    gap: 8px;\n  }\n\n  .logo {\n    width: 98px;\n  }\n\n  .logoButton {\n    min-height: 44px;\n  }\n\n  .headerButtons {\n    gap: 6px;\n  }\n\n  .signInBtn {\n    min-height: 44px;\n    padding: 0 8px;\n    gap: 4px;\n    font-size: 12px;\n  }\n\n  .signUpBtn {\n    min-height: 44px;\n    padding: 0 10px;\n    font-size: 12px;\n  }\n\n  .profileBtn {\n    width: 44px;\n    height: 44px;\n  }\n\n  .trustBarGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 14px 8px;\n  }\n\n  .trustBarCard {\n    padding: 18px 16px;\n  }\n\n  .trustItem {\n    gap: 8px;\n  }\n\n  .trustIcon {\n    width: 38px;\n    height: 38px;\n  }\n\n  .trustText {\n    font-size: 16px;\n  }\n\n  .trustSubtext {\n    font-size: 8px;\n    letter-spacing: 0.05em;\n    overflow-wrap: anywhere;\n  }\n\n  .orderCard {\n    height: 320px;\n  }\n\n  .orderCardTitle {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 600px) {\n  .footerGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footerBrand {\n    grid-column: span 2;\n  }\n\n  .footerGrid > .footerColumn:nth-child(4),\n  .footerGrid > .footerColumn:last-child {\n    grid-column: span 2;\n  }\n\n  .footerGrid > .footerColumn:nth-child(4) ul {\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 18px;\n  }\n\n}\n\n@media (min-width: 601px) and (max-width: 992px) {\n  .footerGrid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    column-gap: 20px;\n  }\n\n  .footerGrid > .footerColumn:last-child {\n    grid-column: span 3;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 768px) {\n  .newsletterForm {\n    flex-direction: row;\n    gap: 8px;\n  }\n\n  .newsletterInput {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .newsletterBtn {\n    width: auto;\n    padding-right: 18px;\n    padding-left: 18px;\n  }\n}\n\n@media (max-width: 359px) {\n  .innerWrapper {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .header .innerWrapper {\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n\n  .logo {\n    width: 82px;\n  }\n\n  .signInBtn {\n    padding-right: 7px;\n    padding-left: 7px;\n  }\n\n  .signUpBtn {\n    padding-right: 9px;\n    padding-left: 9px;\n  }\n\n  .newsletter {\n    padding: 30px 0 26px;\n  }\n\n  .newsletterTitle {\n    font-size: 25px;\n  }\n\n  .footerGrid {\n    column-gap: 16px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pageWrapper *,\n  .pageWrapper *::before,\n  .pageWrapper *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* ===== Landing experience refinement ===== */\n.pageWrapper {\n  overflow-x: clip;\n  color: #0b1c30;\n}\n\n.heroViewport {\n  min-height: 0;\n}\n\n.sectionEyebrow {\n  margin: 0 0 10px;\n  color: #0a64f9;\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.13em;\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n.header .innerWrapper {\n  display: grid;\n  grid-template-columns: minmax(160px, 1fr) auto minmax(160px, 1fr);\n}\n\n.logoButton {\n  justify-self: start;\n}\n\n.headerNav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.headerNavLink {\n  min-height: 40px;\n  padding: 0 13px;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  color: #bdcde0;\n  font-size: 13px;\n  font-weight: 720;\n  line-height: 20px;\n  text-decoration: none;\n  white-space: nowrap;\n  transition:\n    color 160ms ease,\n    border-color 160ms ease,\n    background 160ms ease;\n}\n\n.headerNavLink:hover {\n  border-color: rgba(151, 183, 221, 0.18);\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n.headerButtons {\n  justify-self: end;\n}\n\n.trustBar {\n  margin-top: -48px;\n  margin-bottom: 0;\n}\n\n.trustBarCard {\n  padding: 25px 34px;\n  border: 1px solid rgba(211, 224, 240, 0.85);\n  background:\n    radial-gradient(circle at 8% 20%, rgba(10, 100, 249, 0.07), transparent 24%),\n    rgba(255, 255, 255, 0.97);\n  box-shadow:\n    0 24px 60px rgba(19, 54, 101, 0.1),\n    0 2px 8px rgba(19, 54, 101, 0.05);\n  backdrop-filter: blur(16px);\n}\n\n.trustIcon {\n  width: 44px;\n  height: 44px;\n  background: linear-gradient(145deg, #edf5ff, #dceaff);\n}\n\n.trustText {\n  font-size: 22px;\n}\n\n.trustSubtext {\n  font-size: 10px;\n}\n\n.categoryStrip {\n  padding: 70px 0 62px;\n  scroll-margin-top: 72px;\n  background:\n    radial-gradient(circle at 100% 0, rgba(10, 100, 249, 0.06), transparent 30%),\n    #fff;\n}\n\n.categoryHeader {\n  margin-bottom: 22px;\n  align-items: flex-end;\n}\n\n.categoryTitle {\n  margin: 0;\n  color: #081d38;\n  font-size: clamp(30px, 3.4vw, 44px);\n  font-weight: 880;\n  letter-spacing: -0.045em;\n  line-height: 1.06;\n}\n\n.categoryDescription {\n  max-width: 590px;\n  margin: 12px 0 0;\n  color: #64748b;\n  font-size: 15px;\n  line-height: 1.65;\n}\n\n.categoryNavButtons {\n  gap: 10px;\n}\n\n.categoryArrow {\n  width: 48px;\n  height: 48px;\n  border-color: #dbe5f0;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 7px 20px rgba(21, 52, 92, 0.06);\n}\n\n.categoryArrow:hover:not(:disabled) {\n  border-color: #8bb8ff;\n  background: #edf5ff;\n  box-shadow: 0 9px 24px rgba(10, 100, 249, 0.13);\n  transform: translateY(-2px);\n}\n\n.categorySwipeHint {\n  display: none;\n}\n\n.categoryPills {\n  gap: 14px;\n  padding: 7px 4px 13px;\n  scroll-padding-inline: 4px;\n}\n\n.categoryPill {\n  position: relative;\n  width: 150px;\n  min-height: 154px;\n  padding: 17px 14px 18px;\n  gap: 10px;\n  overflow: hidden;\n  border: 1px solid #e1eaf5;\n  border-radius: 22px;\n  background:\n    linear-gradient(150deg, rgba(242, 247, 255, 0.68), transparent 42%),\n    #fff;\n  box-shadow:\n    0 12px 28px rgba(25, 56, 96, 0.06),\n    0 1px 3px rgba(25, 56, 96, 0.04);\n  transition:\n    border-color 220ms ease,\n    box-shadow 220ms ease,\n    transform 220ms ease;\n}\n\n.categoryPill::before {\n  position: absolute;\n  inset: auto -28px -40px auto;\n  width: 86px;\n  height: 86px;\n  border-radius: 50%;\n  background: rgba(10, 100, 249, 0.055);\n  content: '';\n  transition: transform 220ms ease;\n}\n\n.categoryPill:hover {\n  border-color: #bdd6fa;\n  box-shadow:\n    0 18px 36px rgba(10, 100, 249, 0.12),\n    0 2px 5px rgba(25, 56, 96, 0.05);\n  transform: translateY(-4px);\n}\n\n.categoryPill:hover::before {\n  transform: scale(1.25);\n}\n\n.categoryIconContainer {\n  width: 68px;\n  height: 68px;\n  border-radius: 19px;\n  background: linear-gradient(145deg, #eef5ff, #dceaff);\n  box-shadow: inset 0 0 0 1px rgba(10, 100, 249, 0.06);\n  color: #0a58d3;\n}\n\n.categoryPill:hover .categoryIconContainer {\n  background: linear-gradient(145deg, #1474ff, #0755d8);\n  box-shadow: 0 10px 22px rgba(10, 100, 249, 0.22);\n  transform: translateY(-1px) rotate(-2deg);\n}\n\n.categoryPillLabel {\n  position: relative;\n  z-index: 1;\n  max-width: 100%;\n  color: #142b48;\n  font-size: 13px;\n  font-weight: 780;\n  line-height: 18px;\n  text-wrap: balance;\n}\n\n.categoryPillArrow {\n  position: absolute;\n  z-index: 1;\n  top: 12px;\n  right: 12px;\n  color: #9aabc0;\n  transition:\n    color 180ms ease,\n    transform 180ms ease;\n}\n\n.categoryPill:hover .categoryPillArrow {\n  color: #0a64f9;\n  transform: translate(2px, -2px);\n}\n\n.categoryIconLoader {\n  animation: spin 0.9s linear infinite;\n}\n\n.howSection {\n  padding: 70px 0 76px;\n  scroll-margin-top: 72px;\n  background:\n    linear-gradient(rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.52)),\n    radial-gradient(circle at 12% 20%, rgba(10, 100, 249, 0.12), transparent 30%),\n    #eef4fc;\n  border-top: 1px solid #e3ebf5;\n  border-bottom: 1px solid #dfe9f4;\n}\n\n.howHeader {\n  margin-bottom: 30px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.7fr);\n  align-items: end;\n  gap: 64px;\n}\n\n.howTitle {\n  max-width: 720px;\n  margin: 0;\n  color: #071c38;\n  font-size: clamp(34px, 4.2vw, 54px);\n  font-weight: 890;\n  letter-spacing: -0.052em;\n  line-height: 1.02;\n  text-wrap: balance;\n}\n\n.howDescription {\n  margin: 0 0 3px;\n  color: #5e7087;\n  font-size: 15px;\n  font-weight: 540;\n  line-height: 1.7;\n}\n\n.howGrid {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n  list-style: none;\n  counter-reset: landing-step;\n}\n\n.howCard {\n  position: relative;\n  min-width: 0;\n  min-height: 214px;\n  padding: 24px 24px 22px;\n  overflow: hidden;\n  border: 1px solid #dce7f3;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.91);\n  box-shadow: 0 16px 42px rgba(27, 60, 101, 0.07);\n  list-style: none;\n  transition:\n    border-color 220ms ease,\n    box-shadow 220ms ease,\n    transform 220ms ease;\n}\n\n.howCard::after {\n  content: none;\n}\n\n.howCard:hover {\n  border-color: #bcd4f6;\n  box-shadow: 0 22px 48px rgba(10, 78, 178, 0.11);\n  transform: translateY(-4px);\n}\n\n.howCardTop {\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.howStep {\n  color: #8da0b7;\n  font-size: 12px;\n  font-weight: 850;\n  letter-spacing: 0.12em;\n}\n\n.howIcon {\n  width: 50px;\n  height: 50px;\n  display: grid;\n  place-items: center;\n  border-radius: 15px;\n  background: linear-gradient(145deg, #126eff, #0751cc);\n  box-shadow: 0 10px 24px rgba(8, 83, 209, 0.22);\n  color: #fff;\n}\n\n.howCardTitle {\n  position: relative;\n  z-index: 1;\n  margin: 0 0 10px;\n  color: #102843;\n  font-size: 20px;\n  font-weight: 830;\n  letter-spacing: -0.025em;\n  line-height: 1.2;\n}\n\n.howCardText {\n  position: relative;\n  z-index: 1;\n  max-width: 340px;\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.65;\n}\n\n.orderOptions {\n  padding: 70px 0 76px;\n  background:\n    radial-gradient(circle at 94% 0, rgba(19, 113, 255, 0.22), transparent 32%),\n    radial-gradient(circle at 0 100%, rgba(24, 85, 169, 0.18), transparent 30%),\n    #071c37;\n}\n\n.orderOptionsHeader {\n  margin-bottom: 32px;\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.65fr);\n  align-items: end;\n  gap: 64px;\n  text-align: left;\n}\n\n.orderOptions .sectionEyebrow {\n  color: #75adff;\n}\n\n.sectionTitle {\n  max-width: 720px;\n  margin: 0;\n  color: #fff;\n  font-size: clamp(34px, 4.2vw, 54px);\n  font-weight: 890;\n  letter-spacing: -0.052em;\n  line-height: 1.02;\n  text-wrap: balance;\n}\n\n.sectionSubtitle {\n  max-width: 460px;\n  margin: 0 0 3px;\n  color: #b5c5d9;\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.orderOptionsGrid {\n  gap: 20px;\n}\n\n.orderCard {\n  height: clamp(400px, 31vw, 440px);\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 28px;\n  background: #102744;\n  box-shadow: 0 22px 50px rgba(0, 8, 24, 0.24);\n}\n\n.orderCardImageFull {\n  filter: saturate(0.9) contrast(1.02);\n}\n\n.orderCardOverlay {\n  background:\n    linear-gradient(to top, rgba(2, 14, 31, 0.96) 0%, rgba(3, 19, 41, 0.7) 47%, rgba(3, 19, 41, 0.12) 78%),\n    linear-gradient(110deg, rgba(5, 25, 52, 0.34), transparent 55%);\n}\n\n.orderCardContentOverlay {\n  padding: 30px;\n}\n\n.orderCardTopline {\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.orderCardNumber {\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.14em;\n}\n\n.orderCardMode {\n  min-height: 30px;\n  padding: 5px 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 999px;\n  background: rgba(7, 28, 55, 0.46);\n  color: #dce8f8;\n  font-size: 10px;\n  font-weight: 760;\n  letter-spacing: 0.02em;\n  backdrop-filter: blur(10px);\n}\n\n.orderCardBadge {\n  margin-bottom: 13px;\n  background: #0a64f9;\n}\n\n.orderCardTitle {\n  margin: 0 0 10px;\n  font-size: clamp(31px, 3.2vw, 43px);\n  line-height: 1.04;\n}\n\n.orderCardText {\n  max-width: 450px;\n  padding-bottom: 18px;\n  color: #d1deee;\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.orderCardBtnPrimary,\n.orderCardBtnOutline {\n  min-height: 50px;\n  padding: 0 20px;\n  border: 1px solid rgba(255, 255, 255, 0.84);\n  border-radius: 13px;\n  font-size: 14px;\n  font-weight: 790;\n  transition:\n    background 180ms ease,\n    box-shadow 180ms ease,\n    transform 180ms ease;\n}\n\n.orderCardBtnPrimary:hover,\n.orderCardBtnOutline:hover {\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.19);\n  transform: translateY(-2px);\n}\n\n.orderCardBtnPrimary svg,\n.orderCardBtnOutline svg,\n.partnerGlassBtn svg {\n  transition: transform 180ms ease;\n}\n\n.orderCardBtnPrimary:hover svg,\n.orderCardBtnOutline:hover svg,\n.partnerGlassBtn:hover svg {\n  transform: translateX(3px);\n}\n\n.partnerSection {\n  padding: clamp(42px, 4.8vw, 58px) 0;\n  scroll-margin-top: 72px;\n  background:\n    radial-gradient(circle at 7% 8%, rgba(10, 100, 249, 0.1), transparent 27%),\n    radial-gradient(circle at 94% 92%, rgba(77, 97, 255, 0.07), transparent 24%),\n    linear-gradient(180deg, #f7faff 0%, #f2f7fd 100%);\n}\n\n.partnerCard {\n  position: relative;\n  min-height: 548px;\n  padding: 42px 40px 42px 50px;\n  display: grid;\n  grid-template-columns: minmax(0, 0.86fr) minmax(0, 1.14fr);\n  align-items: center;\n  gap: clamp(30px, 3.6vw, 54px);\n  overflow: hidden;\n  isolation: isolate;\n  border: 1px solid rgba(132, 187, 255, 0.25);\n  border-radius: 36px;\n  background:\n    radial-gradient(circle at 78% 46%, rgba(24, 116, 255, 0.2), transparent 31%),\n    radial-gradient(circle at 10% 112%, rgba(72, 101, 255, 0.3), transparent 43%),\n    linear-gradient(\n      110deg,\n      #123f79 0%,\n      #082b58 38%,\n      #030c1c 56%,\n      #01050c 75%,\n      #000000 100%\n    );\n  box-shadow:\n    0 30px 76px rgba(4, 33, 78, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n  text-align: left;\n}\n\n.partnerCard::before {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  background:\n    linear-gradient(90deg, rgba(6, 38, 83, 0.08), rgba(0, 0, 0, 0.14)),\n    linear-gradient(rgba(119, 177, 255, 0.055) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(119, 177, 255, 0.055) 1px, transparent 1px),\n    radial-gradient(circle at 88% 18%, rgba(64, 151, 255, 0.16), transparent 26%);\n  background-size: auto, 40px 40px, 40px 40px, auto;\n  -webkit-mask-image: linear-gradient(90deg, transparent 32%, #000000 64%);\n  mask-image: linear-gradient(90deg, transparent 32%, #000000 64%);\n  content: '';\n  pointer-events: none;\n}\n\n.partnerCardContent {\n  position: relative;\n  min-width: 0;\n  z-index: 3;\n  align-self: center;\n}\n\n.partnerEyebrow {\n  width: fit-content;\n  margin: 0 0 13px;\n  padding: 7px 12px;\n  border: 1px solid rgba(132, 189, 255, 0.34);\n  border-radius: 999px;\n  background: rgba(15, 102, 224, 0.23);\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 820;\n  letter-spacing: 0.1em;\n  line-height: 17px;\n  text-transform: uppercase;\n  backdrop-filter: blur(8px);\n}\n\n.partnerTitle {\n  max-width: 590px;\n  margin: 0 0 14px;\n  color: #ffffff;\n  font-size: clamp(39px, 3.75vw, 49px);\n  letter-spacing: -0.052em;\n  line-height: 1.02;\n  text-wrap: balance;\n}\n\n.partnerDescription {\n  max-width: 500px;\n  padding: 0;\n  margin: 0 0 18px;\n  color: #d7e8ff;\n  font-size: 15.5px;\n  font-weight: 540;\n  line-height: 1.62;\n}\n\n.partnerFeatureList {\n  margin: 0 0 22px;\n  padding: 0;\n  display: flex;\n  flex-flow: row wrap;\n  gap: 9px;\n  list-style: none;\n}\n\n.partnerFeatureList li {\n  min-height: 38px;\n  padding: 7px 11px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: 1px solid rgba(133, 186, 255, 0.27);\n  border-radius: 12px;\n  background: rgba(8, 45, 95, 0.62);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 720;\n  white-space: nowrap;\n}\n\n.partnerFeatureList svg {\n  color: #8fc0ff;\n}\n\n.partnerGlassBtn {\n  min-height: 48px;\n  padding: 0 20px;\n  border-color: #ffffff;\n  background: #ffffff;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);\n  color: #0758dd;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.partnerGlassBtn:hover {\n  background: #eef6ff;\n  box-shadow: 0 15px 34px rgba(0, 0, 0, 0.24);\n}\n\n.partnerExperience {\n  position: relative;\n  z-index: 2;\n  width: min(100%, 700px);\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n  align-self: center;\n  justify-self: end;\n  isolation: isolate;\n}\n\n.partnerExperience::before {\n  position: absolute;\n  z-index: -1;\n  top: 7%;\n  right: -6%;\n  bottom: 7%;\n  left: 8%;\n  border: 1px solid rgba(86, 158, 255, 0.12);\n  border-radius: 30px;\n  background: linear-gradient(\n    135deg,\n    rgba(27, 110, 235, 0.12),\n    rgba(37, 52, 104, 0.02)\n  );\n  content: '';\n  pointer-events: none;\n  transform: rotate(2.2deg);\n}\n\n.newsletter {\n  padding: 44px 0;\n  background: #fff;\n  text-align: left;\n}\n\n.newsletterCard {\n  padding: 31px 34px;\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1.1fr);\n  align-items: center;\n  gap: clamp(34px, 6vw, 86px);\n  border: 1px solid #dce6f2;\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at 0 0, rgba(10, 100, 249, 0.09), transparent 35%),\n    linear-gradient(145deg, #fbfdff, #f1f6fd);\n  box-shadow: 0 15px 42px rgba(21, 54, 96, 0.07);\n}\n\n.newsletterIntro {\n  min-width: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.newsletterIcon {\n  width: 46px;\n  height: 46px;\n  display: grid;\n  place-items: center;\n  flex: 0 0 46px;\n  border-radius: 14px;\n  background: linear-gradient(145deg, #1474ff, #0754d4);\n  box-shadow: 0 10px 23px rgba(8, 82, 207, 0.2);\n  color: #fff;\n}\n\n.newsletterTitle {\n  margin: 1px 0 6px;\n  font-size: clamp(24px, 2.35vw, 31px);\n  line-height: 1.1;\n}\n\n.newsletterSubtitle {\n  max-width: 480px;\n  margin: 0;\n  color: #5d7088;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.newsletterSignup {\n  min-width: 0;\n  align-items: stretch;\n}\n\n.newsletterFormWrapper {\n  min-width: 0;\n  max-width: none;\n  margin: 0;\n}\n\n.newsletterForm {\n  position: relative;\n  min-width: 0;\n  gap: 9px;\n}\n\n.newsletterInputIcon {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 16px;\n  display: grid;\n  place-items: center;\n  color: #708299;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.newsletterInput {\n  min-height: 54px;\n  padding: 0 16px 0 45px;\n  border-color: #cedbea !important;\n  background: #fff !important;\n  font-size: 14px;\n}\n\n.newsletterInput:focus {\n  box-shadow: 0 0 0 4px rgba(10, 100, 249, 0.1);\n}\n\n.newsletterBtn {\n  min-height: 54px;\n  padding: 0 22px;\n  font-size: 14px;\n}\n\n.newsletterTerms {\n  margin: 9px 0 0;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.newsletterTerms a {\n  color: #315f9d;\n  font-weight: 700;\n  text-underline-offset: 2px;\n}\n\n.visuallyHidden {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.footer {\n  padding-top: 27px;\n}\n\n.footerGrid {\n  margin-bottom: 16px;\n}\n\n.footerContactLink svg {\n  flex: 0 0 auto;\n  color: #75adff;\n}\n\n.headerNavLink:focus-visible,\n.newsletterTerms a:focus-visible {\n  outline: 2px solid #75adff;\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n@media (max-width: 1080px) {\n  .header .innerWrapper {\n    grid-template-columns: minmax(140px, 1fr) auto minmax(140px, 1fr);\n  }\n\n  .headerNavLink {\n    padding-right: 9px;\n    padding-left: 9px;\n    font-size: 12px;\n  }\n\n  .howHeader,\n  .orderOptionsHeader {\n    gap: 36px;\n  }\n\n  .partnerCard {\n    padding: 39px 32px 39px 40px;\n    grid-template-columns: minmax(0, 0.84fr) minmax(0, 1.16fr);\n    gap: 28px;\n  }\n\n  .partnerTitle {\n    font-size: clamp(37px, 4.1vw, 47px);\n  }\n\n  .partnerExperience {\n    margin: 0;\n    padding: 0;\n  }\n\n  .newsletterCard {\n    grid-template-columns: minmax(0, 0.9fr) minmax(380px, 1.1fr);\n    gap: 32px;\n  }\n}\n\n@media (max-width: 900px) {\n  .header .innerWrapper {\n    display: flex;\n  }\n\n  .headerNav {\n    display: none;\n  }\n\n  .howHeader,\n  .orderOptionsHeader {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .howDescription,\n  .sectionSubtitle {\n    max-width: 640px;\n  }\n\n  .howGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .howCard {\n    min-height: 0;\n  }\n\n  .howCardTop {\n    margin-bottom: 22px;\n  }\n\n  .partnerCard {\n    min-height: 0;\n    padding: 42px 40px 38px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 28px;\n    background:\n      radial-gradient(circle at 70% 64%, rgba(13, 111, 255, 0.16), transparent 32%),\n      radial-gradient(circle at 10% 25%, rgba(76, 108, 255, 0.2), transparent 36%),\n      linear-gradient(\n        180deg,\n        #103e79 0%,\n        #082b59 45%,\n        #010813 59%,\n        #000000 70%,\n        #000000 100%\n      );\n    text-align: left;\n  }\n\n  .partnerCardContent {\n    max-width: 680px;\n  }\n\n  .partnerTitle {\n    max-width: 670px;\n  }\n\n  .partnerDescription {\n    max-width: 620px;\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .partnerExperience {\n    width: min(100%, 720px);\n    margin-right: 0;\n    padding: 0;\n    justify-self: center;\n  }\n\n  .partnerExperience::before {\n    top: 9%;\n    right: -3%;\n    bottom: 9%;\n    left: 5%;\n  }\n\n  .newsletterCard {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .heroViewport {\n    min-height: 0;\n  }\n\n  .trustBar {\n    margin-top: -31px;\n    padding: 0 16px;\n  }\n\n  .trustBarCard {\n    padding: 18px 17px;\n    border-radius: 18px;\n  }\n\n  .trustBarGrid {\n    gap: 16px 10px;\n  }\n\n  .trustItem {\n    gap: 9px;\n  }\n\n  .trustIcon {\n    width: 38px;\n    height: 38px;\n  }\n\n  .trustIcon svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .trustText {\n    font-size: 17px;\n  }\n\n  .trustSubtext {\n    font-size: 9.5px;\n    line-height: 1.25;\n  }\n\n  .categoryStrip {\n    padding: 48px 0 44px;\n  }\n\n  .categoryHeader {\n    margin-bottom: 13px;\n  }\n\n  .categoryTitle {\n    font-size: clamp(29px, 8vw, 37px);\n  }\n\n  .categoryDescription {\n    margin-top: 9px;\n    font-size: 14px;\n  }\n\n  .categorySwipeHint {\n    min-height: 27px;\n    margin: 0 0 8px;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: #6f8198;\n    font-size: 10px;\n    font-weight: 760;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  .categoryScrollWrapper {\n    margin-right: -20px;\n  }\n\n  .categoryPills {\n    gap: 11px;\n    padding-right: 20px;\n    padding-bottom: 11px;\n  }\n\n  .categoryPill {\n    width: clamp(120px, 38vw, 136px);\n    min-height: 130px;\n    padding: 13px 10px;\n    border-radius: 19px;\n  }\n\n  .categoryIconContainer {\n    width: 61px;\n    height: 61px;\n    border-radius: 17px;\n  }\n\n  .categoryIconContainer svg {\n    width: 28px;\n    height: 28px;\n  }\n\n  .howSection {\n    padding: 48px 0 52px;\n  }\n\n  .howHeader {\n    margin-bottom: 22px;\n  }\n\n  .howTitle,\n  .sectionTitle {\n    font-size: clamp(31px, 8.5vw, 42px);\n  }\n\n  .howDescription,\n  .sectionSubtitle {\n    font-size: 14px;\n    line-height: 1.6;\n  }\n\n  .howGrid {\n    gap: 12px;\n  }\n\n  .howCard {\n    padding: 19px 20px;\n    border-radius: 20px;\n  }\n\n  .howCardTop {\n    margin-bottom: 14px;\n  }\n\n  .howIcon {\n    width: 43px;\n    height: 43px;\n  }\n\n  .orderOptions {\n    padding: 50px 0 54px;\n  }\n\n  .orderOptionsHeader {\n    margin-bottom: 23px;\n  }\n\n  .orderOptionsGrid {\n    gap: 12px;\n  }\n\n  .orderCard {\n    height: 340px;\n    border-radius: 23px;\n  }\n\n  .orderCardContentOverlay {\n    padding: 21px;\n  }\n\n  .orderCardTopline {\n    margin-bottom: 11px;\n  }\n\n  .orderCardTitle {\n    font-size: 30px;\n  }\n\n  .orderCardText {\n    padding-bottom: 13px;\n  }\n\n  .partnerSection {\n    padding: 44px 0;\n  }\n\n  .partnerCard {\n    min-height: 0;\n    padding: 34px 29px 29px;\n    gap: 24px;\n    border-radius: 28px;\n  }\n\n  .partnerCardContent {\n    max-width: 100%;\n  }\n\n  .partnerTitle {\n    font-size: clamp(35px, 8vw, 46px);\n  }\n\n  .partnerFeatureList {\n    max-width: 510px;\n  }\n\n  .partnerExperience {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  .newsletter {\n    padding: 32px 0;\n  }\n\n  .newsletterCard {\n    padding: 26px;\n    gap: 22px;\n    border-radius: 21px;\n  }\n\n  .newsletterIntro {\n    gap: 12px;\n  }\n\n  .newsletterTitle {\n    font-size: 26px;\n  }\n\n  .newsletterForm {\n    flex-direction: row;\n  }\n\n  .newsletterBtn {\n    width: auto;\n  }\n\n  .footer {\n    padding-top: 24px;\n  }\n\n  .footerGrid {\n    gap: 18px 20px;\n    margin-bottom: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sectionEyebrow {\n    margin-bottom: 7px;\n    font-size: 10px;\n  }\n\n  .header .innerWrapper {\n    padding-right: 12px;\n    padding-left: 12px;\n  }\n\n  .logo {\n    width: 102px;\n  }\n\n  .signInBtn {\n    min-width: 40px;\n    padding: 0 9px;\n  }\n\n  .signUpBtn {\n    padding: 0 11px;\n  }\n\n  .trustBarGrid {\n    gap: 14px 8px;\n  }\n\n  .trustBarCard {\n    padding: 17px 14px;\n  }\n\n  .trustItem {\n    gap: 7px;\n  }\n\n  .trustIcon {\n    width: 35px;\n    height: 35px;\n  }\n\n  .trustText {\n    font-size: 16px;\n  }\n\n  .trustSubtext {\n    font-size: 9.5px;\n    letter-spacing: 0.035em;\n  }\n\n  .categoryStrip {\n    padding-top: 44px;\n    padding-bottom: 40px;\n  }\n\n  .categoryScrollWrapper {\n    margin-right: -20px;\n  }\n\n  .categoryPill {\n    width: clamp(120px, 38vw, 136px);\n  }\n\n  .howCard {\n    padding: 18px;\n  }\n\n  .howCardTitle {\n    font-size: 19px;\n  }\n\n  .orderCard {\n    height: 330px;\n  }\n\n  .orderCardContentOverlay {\n    padding: 19px;\n  }\n\n  .orderCardMode {\n    padding-right: 8px;\n    padding-left: 8px;\n    font-size: 9px;\n  }\n\n  .orderCardBadge {\n    font-size: 9px;\n  }\n\n  .orderCardTitle {\n    font-size: 28px;\n  }\n\n  .orderCardText {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n\n  .orderCardBtnPrimary,\n  .orderCardBtnOutline {\n    min-height: 48px;\n    padding-right: 17px;\n    padding-left: 17px;\n    font-size: 13px;\n  }\n\n  .partnerCard {\n    padding: 26px 19px 22px;\n    gap: 21px;\n    border-radius: 24px;\n  }\n\n  .partnerEyebrow {\n    font-size: 9px;\n  }\n\n  .partnerTitle {\n    font-size: clamp(32px, 9.5vw, 39px);\n    line-height: 1.02;\n  }\n\n  .partnerDescription {\n    font-size: 14px;\n    line-height: 1.55;\n  }\n\n  .partnerFeatureList {\n    display: flex;\n    gap: 6px;\n  }\n\n  .partnerFeatureList li {\n    width: fit-content;\n    min-height: 32px;\n    padding: 6px 8px;\n    font-size: 10.5px;\n  }\n\n  .partnerExperience {\n    width: 100%;\n    padding: 0;\n  }\n\n  .newsletter {\n    padding: 26px 0;\n  }\n\n  .newsletterCard {\n    padding: 23px 20px;\n    gap: 19px;\n  }\n\n  .newsletterIcon {\n    width: 42px;\n    height: 42px;\n    flex-basis: 42px;\n  }\n\n  .newsletterTitle {\n    font-size: 23px;\n  }\n\n  .newsletterSubtitle {\n    font-size: 13px;\n  }\n\n  .newsletterForm {\n    width: 100%;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .newsletterInput {\n    width: 100%;\n    min-height: 50px;\n    padding-right: 11px;\n    padding-left: 40px;\n    font-size: 13px;\n  }\n\n  .newsletterInputIcon {\n    top: 25px;\n    left: 13px;\n  }\n\n  .newsletterBtn {\n    width: 100%;\n    min-height: 50px;\n    padding-right: 16px;\n    padding-left: 16px;\n    font-size: 13px;\n  }\n\n  .newsletterTerms {\n    max-width: 100%;\n    font-size: 10px;\n    line-height: 1.45;\n    overflow-wrap: anywhere;\n  }\n\n  .footerGrid {\n    gap: 14px 18px;\n  }\n\n  .footerBrand {\n    gap: 8px;\n  }\n\n  .footerBrandDescription {\n    font-size: 13px;\n  }\n\n  .footerColumn h4 {\n    margin-bottom: 5px;\n  }\n\n  .footerColumn a {\n    min-height: 38px;\n  }\n\n  .footerContactLink {\n    min-height: 42px;\n  }\n\n  .footerBottom {\n    padding-top: 12px;\n    padding-bottom: 14px;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .partnerDescription {\n    max-width: 450px;\n  }\n\n  .partnerFeatureList {\n    max-width: 470px;\n  }\n\n  .partnerExperience {\n    width: min(100%, 520px);\n  }\n}\n\n@media (min-width: 640px) and (max-width: 768px) {\n  .partnerCard {\n    min-height: 0;\n    padding: 34px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    align-items: center;\n    gap: 26px;\n  }\n\n  .partnerCardContent {\n    max-width: 620px;\n  }\n\n  .partnerTitle {\n    font-size: clamp(36px, 5.8vw, 44px);\n  }\n\n  .partnerExperience {\n    width: min(100%, 620px);\n    margin: 0 auto;\n  }\n}\n\n@media (min-width: 720px) and (max-width: 959px) {\n  .partnerCard {\n    min-height: 0;\n    padding: 38px 38px 34px;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 28px;\n    background:\n      radial-gradient(circle at 70% 64%, rgba(13, 111, 255, 0.17), transparent 32%),\n      radial-gradient(circle at 10% 25%, rgba(76, 108, 255, 0.21), transparent 36%),\n      linear-gradient(180deg, #103e79 0%, #082b59 42%, #010813 61%, #000000 76%);\n  }\n\n  .partnerCardContent {\n    max-width: 700px;\n  }\n\n  .partnerTitle {\n    max-width: 680px;\n    font-size: clamp(40px, 5.6vw, 50px);\n  }\n\n  .partnerDescription {\n    max-width: 620px;\n    font-size: 15px;\n  }\n\n  .partnerFeatureList {\n    gap: 8px;\n  }\n\n  .partnerFeatureList li {\n    min-height: 36px;\n    padding: 7px 10px;\n    font-size: 11px;\n  }\n\n  .partnerExperience {\n    width: min(100%, 720px);\n    margin: 0 auto;\n    padding: 0;\n    justify-self: center;\n  }\n\n  .partnerExperience::before {\n    top: 9%;\n    right: -3%;\n    bottom: 9%;\n    left: 5%;\n    display: block;\n  }\n\n}\n\n@media (min-width: 720px) and (max-width: 992px) {\n  .howGrid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .howCard {\n    min-height: 250px;\n    padding: 18px;\n  }\n\n  .orderOptionsGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .orderCard {\n    height: 380px;\n  }\n}\n\n@media (max-width: 359px) {\n  .header .innerWrapper {\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n\n  .logo {\n    width: 86px;\n  }\n\n  .signInBtn {\n    padding-right: 7px;\n    padding-left: 7px;\n    font-size: 11px;\n  }\n\n  .signUpBtn {\n    padding-right: 9px;\n    padding-left: 9px;\n    font-size: 11px;\n  }\n\n  .trustBar {\n    padding-right: 11px;\n    padding-left: 11px;\n  }\n\n  .trustBarCard {\n    padding-right: 11px;\n    padding-left: 11px;\n  }\n\n  .trustIcon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .trustText {\n    font-size: 15px;\n  }\n\n  .trustSubtext {\n    font-size: 8.8px;\n  }\n\n  .categoryScrollWrapper {\n    margin-right: -14px;\n  }\n\n  .categoryPills {\n    padding-right: 14px;\n  }\n\n  .categoryPill {\n    width: 121px;\n  }\n\n  .orderCard {\n    height: 334px;\n  }\n\n  .orderCardMode {\n    max-width: 135px;\n    white-space: normal;\n  }\n\n  .newsletterForm {\n    flex-direction: column;\n  }\n\n  .newsletterInputIcon {\n    top: 25px;\n  }\n\n  .newsletterBtn {\n    width: 100%;\n  }\n\n  .footerGrid {\n    column-gap: 14px;\n  }\n}\n\n/* ===== Connected retail showcase ===== */\n.partnerSection {\n  position: relative;\n  padding: clamp(42px, 4.8vw, 62px) 0;\n  overflow: hidden;\n  scroll-margin-top: 72px;\n  background:\n    radial-gradient(circle at 8% 8%, rgba(15, 106, 255, 0.1), transparent 28%),\n    radial-gradient(circle at 92% 90%, rgba(96, 74, 255, 0.07), transparent 25%),\n    linear-gradient(180deg, #f7faff 0%, #f1f6fc 100%);\n  isolation: isolate;\n}\n\n.partnerSection::before {\n  content: none;\n}\n\n.partnerSection::after {\n  content: none;\n}\n\n.partnerSection .innerWrapper {\n  position: relative;\n  z-index: 1;\n  max-width: 1600px;\n}\n\n.partnerCard {\n  position: relative;\n  min-height: 548px;\n  padding: 42px 40px 40px 50px;\n  display: grid;\n  grid-template-columns: minmax(360px, 0.82fr) minmax(0, 1.18fr);\n  align-items: center;\n  gap: clamp(25px, 3vw, 48px);\n  overflow: hidden;\n  isolation: isolate;\n  border: 1px solid rgba(130, 187, 255, 0.24);\n  border-radius: 36px;\n  background:\n    radial-gradient(circle at 79% 44%, rgba(29, 120, 255, 0.2), transparent 32%),\n    radial-gradient(circle at 5% 112%, rgba(67, 101, 255, 0.3), transparent 42%),\n    linear-gradient(116deg, #154984 0%, #0b3364 37%, #061a36 52%, #01050d 100%);\n  box-shadow:\n    0 28px 70px rgba(5, 34, 76, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n  text-align: left;\n}\n\n.partnerCard::before {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  background:\n    linear-gradient(rgba(133, 189, 255, 0.048) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(133, 189, 255, 0.048) 1px, transparent 1px);\n  background-size: 48px 48px;\n  content: '';\n  opacity: 0.72;\n  pointer-events: none;\n  -webkit-mask-image: linear-gradient(90deg, transparent 30%, #000 74%);\n  mask-image: linear-gradient(90deg, transparent 30%, #000 74%);\n}\n\n.partnerCard::after {\n  position: absolute;\n  z-index: 0;\n  width: 430px;\n  height: 430px;\n  right: -190px;\n  bottom: -265px;\n  border-radius: 50%;\n  background: rgba(28, 111, 255, 0.14);\n  box-shadow: 0 0 110px rgba(39, 118, 255, 0.26);\n  content: '';\n  pointer-events: none;\n}\n\n.partnerCardContent {\n  position: relative;\n  z-index: 3;\n  min-width: 0;\n  align-self: center;\n}\n\n.partnerEyebrow {\n  width: fit-content;\n  margin: 0 0 13px;\n  padding: 7px 13px;\n  border: 1px solid rgba(144, 198, 255, 0.3);\n  border-radius: 999px;\n  background: rgba(20, 106, 227, 0.2);\n  color: #edf7ff;\n  font-size: 10px;\n  font-weight: 820;\n  letter-spacing: 0.1em;\n  line-height: 17px;\n  text-transform: uppercase;\n  backdrop-filter: blur(8px);\n}\n\n.partnerTitle {\n  max-width: 560px;\n  margin: 0 0 15px;\n  color: #ffffff;\n  font-size: clamp(38px, 3.45vw, 49px);\n  letter-spacing: -0.052em;\n  line-height: 1.015;\n  text-wrap: balance;\n}\n\n.partnerDescription {\n  max-width: 500px;\n  margin: 0 0 20px;\n  padding: 0;\n  color: #c9ddf7;\n  font-size: 15.5px;\n  font-weight: 540;\n  line-height: 1.62;\n}\n\n.partnerFeatureList {\n  margin: 0 0 24px;\n  padding: 0;\n  display: flex;\n  flex-flow: row wrap;\n  gap: 10px 17px;\n  list-style: none;\n}\n\n.partnerFeatureList li {\n  width: auto;\n  min-height: 28px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  color: #f5f9ff;\n  font-size: 11.5px;\n  font-weight: 720;\n  white-space: nowrap;\n}\n\n.partnerFeatureList svg {\n  flex: 0 0 auto;\n  color: #79b8ff;\n}\n\n.partnerGlassBtn {\n  min-height: 50px;\n  padding: 0 21px;\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  border: 1px solid #ffffff;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 13px 29px rgba(0, 0, 0, 0.18);\n  color: #0758dd;\n  font-size: 14px;\n  font-weight: 800;\n  text-decoration: none;\n  transition:\n    background 180ms ease,\n    box-shadow 180ms ease,\n    transform 180ms ease;\n}\n\n.partnerGlassBtn:hover {\n  background: #eef6ff;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.24);\n  transform: translateY(-2px);\n}\n\n.partnerGlassBtn:focus-visible {\n  outline: 3px solid rgba(255, 255, 255, 0.72);\n  outline-offset: 4px;\n}\n\n.partnerExperience {\n  position: relative;\n  z-index: 2;\n  width: min(100%, 760px);\n  min-width: 0;\n  min-height: 470px;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  justify-self: end;\n  isolation: isolate;\n}\n\n.partnerExperience::before {\n  content: none;\n}\n\n.partnerPlatformHalo {\n  position: absolute;\n  z-index: -1;\n  inset: 3% -11% 5% -2%;\n  border-radius: 50%;\n  background:\n    radial-gradient(circle at 51% 48%, rgba(20, 119, 255, 0.25), transparent 54%),\n    radial-gradient(circle at 72% 72%, rgba(110, 77, 255, 0.2), transparent 43%);\n  filter: blur(42px);\n  opacity: 0.9;\n  pointer-events: none;\n}\n\n.partnerPlatformKicker {\n  margin: 0 0 4px;\n  padding: 0 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #d9eaff;\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.105em;\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n.partnerPlatformPulse {\n  width: 7px;\n  height: 7px;\n  flex: 0 0 7px;\n  border-radius: 50%;\n  background: #3c91ff;\n  box-shadow:\n    0 0 0 5px rgba(60, 145, 255, 0.12),\n    0 0 18px rgba(60, 145, 255, 0.72);\n  animation: partnerPulse 2.2s ease-in-out infinite;\n}\n\n.partnerPlatformKickerLabel {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Animated isometric platform deck (see Components/IsometricShowcase). */\n.partnerShowcase {\n  width: 100%;\n  margin: 2px 0 6px;\n}\n\n/* Animated isometric platform deck (see Components/IsometricShowcase). */\n.partnerShowcase {\n  width: 100%;\n  margin: 2px 0 6px;\n}\n\n.partnerViewTimeline {\n  margin: 4px 0 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: clamp(16px, 2.5vw, 30px);\n  list-style: none;\n}\n\n.partnerViewTimelineItem {\n  min-width: 0;\n  min-height: 52px;\n  padding: 8px 7px 3px;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 9px;\n  color: #d9eaff;\n  text-align: left;\n}\n\n.partnerViewTimelineIcon {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(134, 192, 255, 0.24);\n  border-radius: 10px;\n  background: linear-gradient(\n    145deg,\n    rgba(18, 120, 255, 0.34),\n    rgba(75, 67, 238, 0.25)\n  );\n  color: #dcecff;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.partnerViewTimelineCopy {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.partnerViewTimelineCopy strong,\n.partnerViewTimelineCopy small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.partnerViewTimelineCopy strong {\n  color: inherit;\n  font-size: 10.5px;\n  font-weight: 790;\n}\n\n.partnerViewLabelCompact {\n  display: none;\n}\n\n.partnerViewTimelineCopy small {\n  color: #87a5c8;\n  font-size: 8.8px;\n  font-weight: 620;\n}\n\n@keyframes partnerPulse {\n  50% {\n    opacity: 0.6;\n    transform: scale(0.88);\n  }\n}\n\n@media (max-width: 1120px) {\n  .partnerCard {\n    padding-right: 30px;\n    padding-left: 40px;\n    grid-template-columns: minmax(330px, 0.78fr) minmax(0, 1.22fr);\n    gap: 25px;\n  }\n\n  .partnerTitle {\n    font-size: clamp(36px, 4vw, 45px);\n  }\n\n}\n\n@media (max-width: 959px) {\n  .partnerCard {\n    min-height: 0;\n    padding: 39px 38px 31px;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 25px;\n    background:\n      radial-gradient(circle at 69% 66%, rgba(18, 111, 255, 0.18), transparent 33%),\n      radial-gradient(circle at 8% 20%, rgba(75, 108, 255, 0.2), transparent 36%),\n      linear-gradient(180deg, #12457f 0%, #0a3060 42%, #04142b 59%, #01050d 100%);\n  }\n\n  .partnerCardContent {\n    max-width: 720px;\n  }\n\n  .partnerTitle {\n    max-width: 690px;\n  }\n\n  .partnerDescription {\n    max-width: 640px;\n  }\n\n  .partnerExperience {\n    width: min(100%, 760px);\n    min-height: 0;\n    margin: 0 auto;\n    justify-self: center;\n  }\n\n}\n\n@media (max-width: 768px) {\n  .partnerSection {\n    padding: 40px 0;\n  }\n\n  .partnerCard {\n    padding: 32px 28px 25px;\n    gap: 22px;\n    border-radius: 28px;\n  }\n\n  .partnerTitle {\n    font-size: clamp(35px, 7.2vw, 45px);\n  }\n\n\n}\n\n@media (max-width: 480px) {\n  .partnerSection {\n    padding: 34px 0;\n  }\n\n  .partnerCard {\n    padding: 25px 19px 20px;\n    gap: 18px;\n    border-radius: 24px;\n  }\n\n  .partnerEyebrow {\n    margin-bottom: 10px;\n    padding: 6px 10px;\n    font-size: 8.8px;\n  }\n\n  .partnerTitle {\n    margin-bottom: 13px;\n    font-size: clamp(31px, 9.2vw, 37px);\n    line-height: 1.02;\n  }\n\n  .partnerDescription {\n    margin-bottom: 17px;\n    font-size: 13.7px;\n    line-height: 1.55;\n  }\n\n  .partnerFeatureList {\n    margin-bottom: 20px;\n    gap: 8px 13px;\n  }\n\n  .partnerFeatureList li {\n    min-height: 24px;\n    gap: 5px;\n    font-size: 10.2px;\n  }\n\n  .partnerFeatureList svg {\n    width: 15px;\n    height: 15px;\n  }\n\n  .partnerGlassBtn {\n    width: 100%;\n    min-height: 48px;\n    justify-content: center;\n    padding-right: 15px;\n    padding-left: 15px;\n    font-size: 12.5px;\n  }\n\n  .partnerExperience {\n    width: 100%;\n  }\n\n  .partnerPlatformHalo {\n    inset: 5% -8% 9%;\n    display: block;\n    filter: blur(29px);\n    opacity: 0.64;\n  }\n\n  .partnerPlatformKicker {\n    margin-bottom: 0;\n    padding: 0 2px;\n    font-size: 8px;\n  }\n\n\n\n\n  .partnerViewTimeline {\n    margin-top: 1px;\n    gap: 10px;\n  }\n\n  .partnerViewTimelineItem {\n    min-height: 50px;\n    padding: 10px 2px 3px;\n    grid-template-columns: auto minmax(0, 1fr);\n    gap: 7px;\n  }\n\n  .partnerViewTimelineIcon {\n    width: 28px;\n    height: 28px;\n    border-radius: 9px;\n  }\n\n  .partnerViewTimelineCopy strong {\n    font-size: 9.2px;\n  }\n\n  .partnerViewLabelFull {\n    display: none;\n  }\n\n  .partnerViewLabelCompact {\n    display: inline;\n  }\n\n  .partnerViewTimelineCopy small {\n    display: none;\n  }\n}\n\n@media (max-width: 359px) {\n  .partnerCard {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n\n  .partnerTitle {\n    font-size: 29px;\n  }\n\n\n  .partnerViewTimelineIcon {\n    width: 27px;\n    height: 27px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .partnerGlassBtn {\n    transition: none;\n  }\n\n  .partnerPlatformPulse {\n    animation: none;\n  }\n\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `LandingPageV4_pageWrapper__nkocj`,
	"heroViewport": `LandingPageV4_heroViewport__rSy59`,
	"trustBar": `LandingPageV4_trustBar__oHfgX`,
	"innerWrapper": `LandingPageV4_innerWrapper__jP322`,
	"header": `LandingPageV4_header__7wrpI`,
	"logo": `LandingPageV4_logo__OsjVE`,
	"logoButton": `LandingPageV4_logoButton__qGn+B`,
	"headerButtons": `LandingPageV4_headerButtons__d7rrc`,
	"signInBtn": `LandingPageV4_signInBtn__IPzgy`,
	"signUpBtn": `LandingPageV4_signUpBtn__VZWBW`,
	"profileMenuWrapper": `LandingPageV4_profileMenuWrapper__nTh4O`,
	"profileBtn": `LandingPageV4_profileBtn__w0iq8`,
	"iconSm": `LandingPageV4_iconSm__h-3YS`,
	"profileMenu": `LandingPageV4_profileMenu__+Xzo+`,
	"profileHeader": `LandingPageV4_profileHeader__weHYT`,
	"profileName": `LandingPageV4_profileName__cem-L`,
	"profileEmail": `LandingPageV4_profileEmail__MFvBI`,
	"menuList": `LandingPageV4_menuList__34mGD`,
	"menuItemBtn": `LandingPageV4_menuItemBtn__7jVDt`,
	"menuDivider": `LandingPageV4_menuDivider__qbWQA`,
	"logoutBtn": `LandingPageV4_logoutBtn__HHe98`,
	"trustBarCard": `LandingPageV4_trustBarCard__C43QQ`,
	"trustBarGrid": `LandingPageV4_trustBarGrid__S56x-`,
	"trustItem": `LandingPageV4_trustItem__NkSuB`,
	"trustIcon": `LandingPageV4_trustIcon__-ANnJ`,
	"trustTextWrap": `LandingPageV4_trustTextWrap__r6u5W`,
	"trustText": `LandingPageV4_trustText__jxtdf`,
	"trustSubtext": `LandingPageV4_trustSubtext__TKs1m`,
	"categoryStrip": `LandingPageV4_categoryStrip__Ud+Yg`,
	"categoryHeader": `LandingPageV4_categoryHeader__bAQgF`,
	"categoryHeaderText": `LandingPageV4_categoryHeaderText__K554-`,
	"categoryTitle": `LandingPageV4_categoryTitle__BXOKV`,
	"categoryDescription": `LandingPageV4_categoryDescription__Dd9uU`,
	"categoryNavButtons": `LandingPageV4_categoryNavButtons__fT4BV`,
	"categoryArrow": `LandingPageV4_categoryArrow__8sgtP`,
	"categoryArrowDisabled": `LandingPageV4_categoryArrowDisabled__ukwDy`,
	"categoryScrollWrapper": `LandingPageV4_categoryScrollWrapper__O5aqT`,
	"categoryFadeLeft": `LandingPageV4_categoryFadeLeft__x63YP`,
	"categoryFadeRight": `LandingPageV4_categoryFadeRight__XERjO`,
	"categoryPills": `LandingPageV4_categoryPills__kiyYa`,
	"categoryPill": `LandingPageV4_categoryPill__bHh52`,
	"categoryIconContainer": `LandingPageV4_categoryIconContainer__GB8mM`,
	"contentSection": `LandingPageV4_contentSection__moDt4`,
	"contentSectionReverse": `LandingPageV4_contentSectionReverse__pZZif`,
	"contentText": `LandingPageV4_contentText__QVf6o`,
	"contentTitle": `LandingPageV4_contentTitle__u+nLX`,
	"contentDescription": `LandingPageV4_contentDescription__fXIzg`,
	"contentImage": `LandingPageV4_contentImage__LO-Oi`,
	"ctaBtn": `LandingPageV4_ctaBtn__MWGPU`,
	"orderOptions": `LandingPageV4_orderOptions__onirQ`,
	"orderOptionsHeader": `LandingPageV4_orderOptionsHeader__eEHlu`,
	"sectionTitle": `LandingPageV4_sectionTitle__q9iWx`,
	"sectionSubtitle": `LandingPageV4_sectionSubtitle__tWkjP`,
	"orderOptionsGrid": `LandingPageV4_orderOptionsGrid__gtton`,
	"orderCard": `LandingPageV4_orderCard__cl6WT`,
	"orderCardImageFull": `LandingPageV4_orderCardImageFull__dETSC`,
	"orderCardOverlay": `LandingPageV4_orderCardOverlay__Lc2fS`,
	"orderCardContentOverlay": `LandingPageV4_orderCardContentOverlay__sJmUk`,
	"orderCardBadge": `LandingPageV4_orderCardBadge__ONFKd`,
	"orderCardTitle": `LandingPageV4_orderCardTitle__9Wrq3`,
	"orderCardText": `LandingPageV4_orderCardText__3Kb9a`,
	"orderCardBtnPrimary": `LandingPageV4_orderCardBtnPrimary__W22cs`,
	"orderCardBtnOutline": `LandingPageV4_orderCardBtnOutline__HB1Yo`,
	"partnerSection": `LandingPageV4_partnerSection__dGi7F`,
	"partnerCard": `LandingPageV4_partnerCard__arAP1`,
	"partnerCardContent": `LandingPageV4_partnerCardContent__PJG6c`,
	"partnerTitle": `LandingPageV4_partnerTitle__lXaxl`,
	"partnerDescription": `LandingPageV4_partnerDescription__TKVul`,
	"partnerGlassBtn": `LandingPageV4_partnerGlassBtn__n1+62`,
	"phoneMockup": `LandingPageV4_phoneMockup__8Le8n`,
	"phoneScreen": `LandingPageV4_phoneScreen__n7Wai`,
	"phoneScreenContent": `LandingPageV4_phoneScreenContent__pGBSB`,
	"phoneMerchantHeader": `LandingPageV4_phoneMerchantHeader__t+PPi`,
	"phoneMerchantLabel": `LandingPageV4_phoneMerchantLabel__TDwG2`,
	"phoneMerchantTitle": `LandingPageV4_phoneMerchantTitle__ecGIQ`,
	"phoneMerchantAvatar": `LandingPageV4_phoneMerchantAvatar__rCZwn`,
	"phoneMetricCard": `LandingPageV4_phoneMetricCard__+vngV`,
	"phoneMetricHeader": `LandingPageV4_phoneMetricHeader__Ayh+-`,
	"phoneMetricLabel": `LandingPageV4_phoneMetricLabel__bkJnc`,
	"phoneMetricBadge": `LandingPageV4_phoneMetricBadge__mc1g2`,
	"phoneMetricValue": `LandingPageV4_phoneMetricValue__pI-tx`,
	"phoneChartCard": `LandingPageV4_phoneChartCard__Ygasa`,
	"phoneChartHeader": `LandingPageV4_phoneChartHeader__E8nzc`,
	"phoneChartValue": `LandingPageV4_phoneChartValue__c76YJ`,
	"phoneChartMiniBar": `LandingPageV4_phoneChartMiniBar__+yEir`,
	"phoneMiniBar1": `LandingPageV4_phoneMiniBar1__4XfRW`,
	"phoneMiniBar2": `LandingPageV4_phoneMiniBar2__G2Qdp`,
	"phoneMiniBar3": `LandingPageV4_phoneMiniBar3__o68Z1`,
	"phoneLineChart": `LandingPageV4_phoneLineChart__rA0LR`,
	"phoneBarChartCard": `LandingPageV4_phoneBarChartCard__ebe5c`,
	"phoneBarChartBars": `LandingPageV4_phoneBarChartBars__F0ByG`,
	"phoneBar": `LandingPageV4_phoneBar__C-u3T`,
	"phoneBarActive": `LandingPageV4_phoneBarActive__dwqtq`,
	"phoneNotch": `LandingPageV4_phoneNotch__73TVK`,
	"phoneNotchLine": `LandingPageV4_phoneNotchLine__gGipL`,
	"newsletter": `LandingPageV4_newsletter__DV3bX`,
	"newsletterTitle": `LandingPageV4_newsletterTitle__OMI9U`,
	"newsletterSubtitle": `LandingPageV4_newsletterSubtitle__-kL1i`,
	"newsletterSignup": `LandingPageV4_newsletterSignup__Mv7Mn`,
	"newsletterFormWrapper": `LandingPageV4_newsletterFormWrapper__DXthJ`,
	"newsletterForm": `LandingPageV4_newsletterForm__SlMqm`,
	"newsletterInput": `LandingPageV4_newsletterInput__FNmSs`,
	"newsletterBtn": `LandingPageV4_newsletterBtn__kYFon`,
	"newsletterTerms": `LandingPageV4_newsletterTerms__wLreU`,
	"termsRow": `LandingPageV4_termsRow__jOtzU`,
	"hiddenCheckbox": `LandingPageV4_hiddenCheckbox__sn7M9`,
	"customCheckbox": `LandingPageV4_customCheckbox__vs+4n`,
	"checkIcon": `LandingPageV4_checkIcon__gjn4F`,
	"termsLabel": `LandingPageV4_termsLabel__CKxhZ`,
	"footer": `LandingPageV4_footer__+l-US`,
	"footerNewsletter": `LandingPageV4_footerNewsletter__H373+`,
	"footerContent": `LandingPageV4_footerContent__93wnF`,
	"footerGrid": `LandingPageV4_footerGrid__QMMCm`,
	"footerHelpText": `LandingPageV4_footerHelpText__GsrfR`,
	"footerContactLink": `LandingPageV4_footerContactLink__is6TE`,
	"material-symbols-outlined": `LandingPageV4_material-symbols-outlined__Ug37d`,
	"footerBrand": `LandingPageV4_footerBrand__ol-2d`,
	"footerBrandDescription": `LandingPageV4_footerBrandDescription__kq+iG`,
	"footerColumn": `LandingPageV4_footerColumn__cTUqZ`,
	"footerLegalLink": `LandingPageV4_footerLegalLink__w0dWo`,
	"footerBottom": `LandingPageV4_footerBottom__L6WSo`,
	"footerLogo": `LandingPageV4_footerLogo__t27DJ`,
	"footerSocial": `LandingPageV4_footerSocial__OIJVr`,
	"footerCopyright": `LandingPageV4_footerCopyright__kSRQs`,
	"footerBadges": `LandingPageV4_footerBadges__040Ap`,
	"footerBadge": `LandingPageV4_footerBadge__ltsp9`,
	"sectionEyebrow": `LandingPageV4_sectionEyebrow__PSy7g`,
	"headerNav": `LandingPageV4_headerNav__U19t6`,
	"headerNavLink": `LandingPageV4_headerNavLink__wSFHb`,
	"categorySwipeHint": `LandingPageV4_categorySwipeHint__yuT7O`,
	"categoryPillLabel": `LandingPageV4_categoryPillLabel__sFpNE`,
	"categoryPillArrow": `LandingPageV4_categoryPillArrow__FSSta`,
	"categoryIconLoader": `LandingPageV4_categoryIconLoader__JwIy-`,
	"spin": `LandingPageV4_spin__hGHqY`,
	"howSection": `LandingPageV4_howSection__ugMj8`,
	"howHeader": `LandingPageV4_howHeader__n4mVJ`,
	"howTitle": `LandingPageV4_howTitle__BVSru`,
	"howDescription": `LandingPageV4_howDescription__UUE+x`,
	"howGrid": `LandingPageV4_howGrid__QU9Qg`,
	"howCard": `LandingPageV4_howCard__swxRV`,
	"howCardTop": `LandingPageV4_howCardTop__rW2Z6`,
	"howStep": `LandingPageV4_howStep__gZ+BZ`,
	"howIcon": `LandingPageV4_howIcon__g42Dy`,
	"howCardTitle": `LandingPageV4_howCardTitle__r94bk`,
	"howCardText": `LandingPageV4_howCardText__gyld6`,
	"orderCardTopline": `LandingPageV4_orderCardTopline__aFUmW`,
	"orderCardNumber": `LandingPageV4_orderCardNumber__iDaQx`,
	"orderCardMode": `LandingPageV4_orderCardMode__O+AyS`,
	"partnerEyebrow": `LandingPageV4_partnerEyebrow__RY+c3`,
	"partnerFeatureList": `LandingPageV4_partnerFeatureList__s-SXi`,
	"partnerExperience": `LandingPageV4_partnerExperience__t4iqF`,
	"newsletterCard": `LandingPageV4_newsletterCard__bdoK-`,
	"newsletterIntro": `LandingPageV4_newsletterIntro__KMmr5`,
	"newsletterIcon": `LandingPageV4_newsletterIcon__W7t8k`,
	"newsletterInputIcon": `LandingPageV4_newsletterInputIcon__DxKI9`,
	"visuallyHidden": `LandingPageV4_visuallyHidden__EJxvK`,
	"partnerPlatformHalo": `LandingPageV4_partnerPlatformHalo__cL2Uj`,
	"partnerPlatformKicker": `LandingPageV4_partnerPlatformKicker__UeP-u`,
	"partnerPlatformPulse": `LandingPageV4_partnerPlatformPulse__+Hxd1`,
	"partnerPulse": `LandingPageV4_partnerPulse__LqRUa`,
	"partnerPlatformKickerLabel": `LandingPageV4_partnerPlatformKickerLabel__C-6hJ`,
	"partnerShowcase": `LandingPageV4_partnerShowcase__3L5nz`,
	"partnerViewTimeline": `LandingPageV4_partnerViewTimeline__etnfH`,
	"partnerViewTimelineItem": `LandingPageV4_partnerViewTimelineItem__xOI7p`,
	"partnerViewTimelineIcon": `LandingPageV4_partnerViewTimelineIcon__dYCmU`,
	"partnerViewTimelineCopy": `LandingPageV4_partnerViewTimelineCopy__mAx4F`,
	"partnerViewLabelCompact": `LandingPageV4_partnerViewLabelCompact__1tonz`,
	"partnerViewLabelFull": `LandingPageV4_partnerViewLabelFull__wSsKF`
};
export default ___CSS_LOADER_EXPORT___;
